// calculadoras.js

(function () {
    // --------- CONFIGURATION -----------
    const SHOPIFY_SIZE_FILTER_KEY = 'filter.v.option.tamanho+do+calçado';
    const DEBUG_MODE = false; // Set to true for development/debugging console logs
    const SHOW_LOGOS_INSTEAD_OF_NAME = false;

    // Set to true to show out-of-stock models (with the yellow background) in the size popup
    const SHOW_ALL_PRODUCTS_IN_SIZE_POPUP = false;

    // Sentinel values for infinity replacement in JSON
    const SENTINEL_MIN = -9999;
    const SENTINEL_MAX = 9999;

    // --- Global variable for module configurations ---
    let MODULE_CONFIGS = [];
    let isConfigLoaded = false; // Flag to track if configs are loaded
    let currentResults = [];

    // --- SUB_COLLECTION_SELECTORS and BRAND_LOGOS (These remain defined in JS) ---
    const SUB_COLLECTION_SELECTORS = {
        /* ---- THIS IS THE SECTION YOU ARE REMOVING ----
       'blanditos-small': {
           title: "Ver Stock - Que tipo de Blanditos?",
           options: [
               { name: "Botas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_bota.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-botas-barefoot" },
               { name: "Sapatilhas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Sapatilha.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-sapatilhas" },
               { name: "Sandália Fechada", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Sandalia_fechada.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-sandalia-fechada" },
               { name: "Merceditas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Mercedita.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-merceditas" }
           ]
       }   
       , // <-- You can remove the comma as well
       'blanditos-sapatilha-larga': {
           title: "Ver Stock - Que tipo de Blanditos?",
           options: [
               { name: "Sapatilhas", imageUrl: "...", url: "..." },
               { name: "Botas", imageUrl: "...", url: "..." }
           ]
       }
       */
    };

    const BRAND_LOGOS = {
        'attipas': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/attipas_logo.webp?v=1744325017', 'aylla': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Aylla_logo.png?v=1745070563', 'slipstop': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Slipstop_logo.webp?v=1744326128', 'zastras': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Zastraslogo.webp?v=1744325905', 'froddo': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/froddo_logo.webp?v=1744325017', 'muris': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/muris_logo.webp?v=1744325017', 'mum-barefoot': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/mumbarefoot_logo.webp?v=1744325017', 'blanditos': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/blanditos_logo.webp?v=1744325017', 'igor': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/igor_logo.webp?v=1744325017', 'lassig': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/lassig_logo.webp?v=1744325017', 'babylobitos': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/babylobitos_logo.webp?v=1744325017', 'poppis': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/poppis_logo.webp?v=1744325017', 'victoria': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/victoria_logo.webp?v=1744325017', 'coucoucava': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/coucoucava_logo.webp?v=1744325017', 'pablosky': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/pablosky_logo.webp?v=1744325017', 'waterlemon': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/waterlemon_logo.webp?v=1744325017', 'banannas': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/banannas_logo.webp?v=1744325017', 'dodo': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/dodoshoes_logo.webp?v=1744325017', 'bunny': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/bunnybarefoot_logo.webp?v=1744325017', 'chameleon': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/chameleon_logo.webp?v=1744325017', 'little-dutch': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/littledutch_logo.webp?v=1744325016', 'bigtoes': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/bigtoes_logo.webp?v=1744325017', 'condor': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/condor_logo.webp?v=1744325017', 'duukies': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/duukies_logo.webp?v=1744325017', 'revenge': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/revenge_logo.webp?v=1744325016',
        'boatilus': 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/boatilus_logo.png?v=1748278048'
    };

    const blanditosPopupOptions = [
        { name: "Botas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_bota.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-botas-barefoot" },
        { name: "Sapatilhas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Sapatilha.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-sapatilhas" },
        { name: "Sandália Fechada", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Sandalia_fechada.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-sandalia-fechada" },
        { name: "Merceditas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Mercedita.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-merceditas" }
    ];
    const blanditosSolaLargaPopupOptions = [
        { name: "Sapatilhas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_Sapatilha.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-sapatilhas" },
        { name: "Botas", imageUrl: "https://cdn.shopify.com/s/files/1/0273/9175/4340/files/Blanditos_bota.webp?v=1744037597", url: "https://gotu.pt/collections/blanditos-botas-barefoot" }
    ];

    // --- CACHES ---
    const sizeAvailabilityCache = new Map();
    const saleCache = new Map();
    const productsCache = new Map();
    const activeFetchPromises = new Map();
    let meiasIntervalId = null;

    // --------- UTILITY FUNCTIONS -----------
    function logDebug(...args) { if (DEBUG_MODE) console.log('[Calc Debug]', ...args); }
    function getSelectedFilter() { return document.querySelector('#gotu-barefoot-calculator-app input[name="filter"]:checked')?.value || "Todos"; }
    function shouldProcessModule(filter, selectedFilter) { if (selectedFilter === "Todos") return true; if (Array.isArray(filter)) return filter.includes(selectedFilter); return filter === selectedFilter; }
    function isTwoDigitNumberString(str) { if (typeof str !== 'string') return false; return /^\d{2}$/.test(str); }
    function extractBaseSizeText(str) {
        if (!str || typeof str !== 'string') return null;
        let txt = str;
        const brIndex = txt.indexOf('<br');
        const divIndex = txt.indexOf('<div');
        let endIndex = -1;
        if (brIndex !== -1 && divIndex !== -1) endIndex = Math.min(brIndex, divIndex);
        else if (brIndex !== -1) endIndex = brIndex;
        else if (divIndex !== -1) endIndex = divIndex;
        if (endIndex !== -1) txt = txt.substring(0, endIndex).trim();
        
        // Remove variation selector characters globally (e.g. \uFE0F in warning emojis) to prevent regex matching failures
        txt = txt.replace(/[\uFE00-\uFE0F]/g, '');
        
        txt = txt.replace(/^[✅⚠️❌❗👇👟🤚🩰]\s*|\s*[✅⚠️❌❗👇👟🤚🩰]$/g, '').trim();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = txt;
        txt = (tempDiv.textContent || tempDiv.innerText || "").trim();
        const lowerTxt = txt.toLowerCase();
        if (lowerTxt.includes('verificar') || lowerTxt.includes('guia') || lowerTxt.startsWith('pé ')) return null;
        return txt;
    }
    function sortSizesNumerically(sizes) {
        return sizes.sort((a, b) => {
            const numA = parseFloat(a.match(/^[\d.]+/)?.[0]);
            const numB = parseFloat(b.match(/^[\d.]+/)?.[0]);
            if (!isNaN(numA) && !isNaN(numB)) { return numA - numB; }
            else if (!isNaN(numA)) { return -1; }
            else if (!isNaN(numB)) { return 1; }
            else { return String(a).localeCompare(String(b)); }
        });
    }

    // --------- Drag-to-Scroll Functionality ---------
    function makeScrollable(element) {
        if (!element) return;
        let isDown = false; let startX; let scrollLeft;
        element.addEventListener('pointerdown', (e) => { if (e.button !== 0) return; isDown = true; element.classList.add('active-scroll'); startX = e.pageX - element.offsetLeft; scrollLeft = element.scrollLeft; element.style.cursor = 'grabbing'; element.setPointerCapture(e.pointerId); e.preventDefault(); });
        element.addEventListener('pointerleave', () => { if (isDown) { isDown = false; element.classList.remove('active-scroll'); element.style.cursor = 'grab'; } });
        element.addEventListener('pointerup', (e) => { if (!isDown) return; isDown = false; element.classList.remove('active-scroll'); element.style.cursor = 'grab'; element.releasePointerCapture(e.pointerId); });
        element.addEventListener('pointermove', (e) => { if (!isDown) return; e.preventDefault(); const x = e.pageX - element.offsetLeft; const walk = (x - startX) * 1.5; element.scrollLeft = scrollLeft - walk; });
        element.style.cursor = 'grab';
    }
    function applyDragToScroll() {
        try {
            const scrollableElements = document.querySelectorAll('#gotu-barefoot-calculator-app .scrollable-sizes');
            logDebug(`Applying drag-to-scroll to ${scrollableElements.length} elements.`);
            scrollableElements.forEach(el => { makeScrollable(el); });
        } catch (e) { console.error("Error applying drag-to-scroll:", e); }
    }

    // --------- POPUP FUNCTIONS -----------
    function showBlanditosPopup(options, originalSize = null) {
        try {
            const overlay = document.getElementById('blanditos-popup-overlay'), content = document.getElementById('blanditos-popup-content'), optsCont = document.getElementById('blanditos-popup-options'), closeBtn = document.getElementById('blanditos-popup-close');
            if (!overlay || !content || !optsCont || !closeBtn) { console.error("Blanditos popup elements missing!"); return; }
            logDebug("Showing Blanditos LINK popup (Navigation). Size:", originalSize);
            optsCont.innerHTML = '';
            options.forEach(opt => {
                const a = document.createElement('a');
                a.href = opt.url; a.className = 'popup-option'; a.target = "_blank"; a.rel = "noopener";
                a.innerHTML = `<img src="${opt.imageUrl}" alt="${opt.name}"><span>${opt.name}</span>`; optsCont.appendChild(a);
            });
            overlay.style.display = 'flex'; setTimeout(() => overlay.classList.add('active'), 10);
            const handler = (event) => {
                const clicked = event.target.closest('.popup-option'); if (!clicked) return; event.preventDefault();
                optsCont.querySelectorAll('.popup-option-clicked').forEach(el => el.classList.remove('popup-option-clicked')); clicked.classList.add('popup-option-clicked');
                const base = clicked.href, target = clicked.target; let final = base;
                if (originalSize) {
                    const key = SHOPIFY_SIZE_FILTER_KEY, val = originalSize;
                    try {
                        const urlO = new URL(base, window.location.origin);
                        if (!urlO.searchParams.getAll(key).includes(val)) { urlO.searchParams.append(key, val); }
                        let tmp = urlO.toString(); const enc = encodeURIComponent(key).replace(/%20/g, '+'), cor = key;
                        const rx = new RegExp(encodeURIComponent(enc).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=', 'g');
                        if (rx.test(tmp)) { final = tmp.replace(rx, cor + '='); } else { final = tmp; }
                    } catch (e) {
                        const s = base.includes('?') ? '&' : '?'; const p = `${key}=${encodeURIComponent(val)}`;
                        let b = base, h = ''; if (base.includes('#')) { const ps = base.split('#'); b = ps[0]; h = '#' + ps[1]; }
                        if (!b.includes(p) && !b.includes(key + '=' + val)) { final = b + s + p + h; } else { final = base; }
                    }
                }
                setTimeout(() => {
                    if (overlay.classList.contains('active')) {
                        if (target === "_blank") { window.open(final, '_blank', 'noopener'); clicked.classList.remove('popup-option-clicked'); }
                        else { window.location.href = final; }
                    }
                }, 400);
            };
            const close = () => { if (!overlay) return; overlay.classList.remove('active'); optsCont.querySelectorAll('.popup-option-clicked').forEach(el => el.classList.remove('popup-option-clicked')); setTimeout(() => { if (overlay) overlay.style.display = 'none'; }, 300); closeBtn.removeEventListener('click', close); overlay.removeEventListener('click', outside); optsCont.removeEventListener('click', handler); logDebug("Blanditos link popup closed."); };
            const outside = (e) => { if (e.target === overlay) close(); };
            optsCont.addEventListener('click', handler); closeBtn.addEventListener('click', close); overlay.addEventListener('click', outside);
        } catch (e) { console.error("Error in showBlanditosPopup:", e); }
    }

    function showSubCollectionSelectorPopup(originalClickedSize, selectorConfig, brandVariantText = '', status = 'ideal') {
        try {
            const overlay = document.getElementById('sub-collection-popup-overlay'), content = document.getElementById('sub-collection-popup-content'), titleEl = document.getElementById('sub-collection-popup-title'), optsCont = document.getElementById('sub-collection-popup-options'), closeBtn = document.getElementById('sub-collection-popup-close');
            if (!overlay || !content || !titleEl || !optsCont || !closeBtn || !selectorConfig?.options) { console.error("Sub-collection selector missing elements/config."); alert("Erro ao abrir seletor de coleção."); return; }
            logDebug(`Showing sub-collection selector popup for size ${originalClickedSize}. Config:`, selectorConfig);
            titleEl.textContent = selectorConfig.title || "Selecione o tipo:"; optsCont.innerHTML = '';
            selectorConfig.options.forEach(opt => { const div = document.createElement('div'); div.className = 'popup-option sub-collection-option'; div.dataset.url = opt.url; div.dataset.name = opt.name; div.innerHTML = `<img src="${opt.imageUrl}" alt="${opt.name}"><span>${opt.name}</span>`; optsCont.appendChild(div); });
            overlay.style.display = 'flex'; setTimeout(() => overlay.classList.add('active'), 10);
            const handler = (event) => {
                const clicked = event.target.closest('.sub-collection-option'); if (!clicked) return;
                const url = clicked.dataset.url; const name = clicked.dataset.name; if (!url) { console.error("Clicked sub-collection option has no URL."); return; }
                logDebug(`Sub-collection selected: ${name}, URL: ${url}`);
                optsCont.querySelectorAll('.popup-option-clicked').forEach(el => el.classList.remove('popup-option-clicked')); clicked.classList.add('popup-option-clicked');
                close();
                setTimeout(() => { showProductSizePopup(originalClickedSize, url, brandVariantText, status); }, 150);
            };
            const close = () => { if (!overlay) return; overlay.classList.remove('active'); optsCont.querySelectorAll('.popup-option-clicked').forEach(el => el.classList.remove('popup-option-clicked')); setTimeout(() => { if (overlay) overlay.style.display = 'none'; }, 300); closeBtn.removeEventListener('click', close); overlay.removeEventListener('click', outside); optsCont.removeEventListener('click', handler); logDebug("Sub-collection selector popup closed."); };
            const outside = (e) => { if (e.target === overlay) close(); };
            optsCont.addEventListener('click', handler); closeBtn.addEventListener('click', close); overlay.addEventListener('click', outside);
        } catch (e) { console.error("Error in showSubCollectionSelectorPopup:", e); }
    }

    function showProductSizePopup(size, collectionUrl, brandVariantText = '', status = 'ideal') {
        try {
            const overlay = document.getElementById('product-size-popup-overlay'), title = document.getElementById('product-size-popup-title'), loader = document.getElementById('product-size-popup-loader'), grid = document.getElementById('product-size-popup-grid'), emptyMsg = document.getElementById('product-size-popup-empty'), closeBtn = document.getElementById('product-size-popup-close'), brandVariantEl = document.getElementById('product-size-popup-brand-variant');
            if (!overlay || !title || !loader || !grid || !emptyMsg || !closeBtn || !brandVariantEl) { console.error("Product size popup elements missing!"); alert("Erro ao abrir detalhes do produto."); return; }
            
            let warningEl = document.getElementById('product-size-popup-warning');
            if (!warningEl) {
                warningEl = document.createElement('div');
                warningEl.id = 'product-size-popup-warning';
                warningEl.style.padding = '0.75rem';
                warningEl.style.marginTop = '-0.8rem';
                warningEl.style.marginBottom = '1.2rem';
                warningEl.style.backgroundColor = '#fff8e1';
                warningEl.style.border = '1px solid #ffeeba';
                warningEl.style.borderRadius = '6px';
                warningEl.style.color = '#a05200';
                warningEl.style.fontSize = '0.9rem';
                warningEl.style.fontWeight = '500';
                warningEl.style.textAlign = 'center';
                warningEl.style.lineHeight = '1.4';
                if (brandVariantEl) {
                    brandVariantEl.parentNode.insertBefore(warningEl, brandVariantEl.nextSibling);
                }
            }

            logDebug(`Showing product popup size ${size}, collection ${collectionUrl}, Brand/Variant: ${brandVariantText}, Status: ${status}`);
            title.textContent = `Produtos Disponíveis - Tam. ${size}`;
            if (brandVariantText) { brandVariantEl.textContent = `Marca/Variante: ${brandVariantText}`; brandVariantEl.style.display = 'block'; }
            else { brandVariantEl.textContent = ''; brandVariantEl.style.display = 'none'; }
            
            if (status === 'marginWarning') {
                warningEl.innerHTML = `⚠️ Atenção: Este tamanho tem uma <strong>Margem Não Ideal</strong> para a medida do pé indicada.`;
                warningEl.style.display = 'block';
            } else {
                warningEl.style.display = 'none';
            }
            
            grid.innerHTML = ''; grid.style.display = 'none'; emptyMsg.style.display = 'none'; loader.style.display = 'block'; overlay.style.display = 'flex'; setTimeout(() => overlay.classList.add('active'), 10);
            fetchAndDisplayProducts(size, collectionUrl, status);
            const closeHandler = () => { overlay.classList.remove('active'); setTimeout(() => { overlay.style.display = 'none'; }, 300); closeBtn.removeEventListener('click', closeHandler); overlay.removeEventListener('click', outsideHandler); logDebug("Product size popup closed."); };
            const outsideHandler = (e) => { if (e.target === overlay) closeHandler(); };
            closeBtn.addEventListener('click', closeHandler); overlay.addEventListener('click', outsideHandler);
        } catch (e) { console.error("Error in showProductSizePopup:", e); }
    }
    async function fetchAndDisplayProducts(targetSize, collectionUrl, status = 'ideal') {
        const loader = document.getElementById('product-size-popup-loader'), grid = document.getElementById('product-size-popup-grid'), emptyMsg = document.getElementById('product-size-popup-empty');
        if (!loader || !grid || !emptyMsg) return;
        try {
            let baseUrl = collectionUrl;
            try { const urlObj = new URL(collectionUrl, window.location.origin); baseUrl = urlObj.pathname; }
            catch (e) { logDebug("Couldn't parse collectionUrl, using as is:", collectionUrl); }
            if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);

            const handle = baseUrl.split('/collections/')[1]?.split(/[\/\?#]/)[0];
            let rawProducts = null;
            if (handle && productsCache.has(handle)) {
                logDebug(`Using cached products for grid: ${handle}`);
                rawProducts = productsCache.get(handle).products || [];
            } else {
                const fetchUrl = `${baseUrl}/products.json?limit=250`;
                logDebug(`Fetching products for grid: ${fetchUrl}`);
                const response = await fetch(fetchUrl);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
                const data = await response.json();
                if (!data?.products) throw new Error("Invalid product data received.");
                rawProducts = data.products;
                if (handle) productsCache.set(handle, data);
            }
            let productsToDisplayMapped;
            if (!SHOW_ALL_PRODUCTS_IN_SIZE_POPUP) {
                productsToDisplayMapped = filterProductsForSize(rawProducts, targetSize);
            } else {
                const productsWithAvailabilityMarked = rawProducts.map(product => {
                    let hasTargetSize = false;
                    if (product.variants && product.variants.length > 0) {
                        let sizeOptionKey = null;
                        product.options?.find((opt, index) => {
                            const optionNameLower = opt?.name?.toLowerCase();
                            const sizeOptionIdentifiers = ['tamanho', 'size', 'shoe size', 'talla'];
                            if (optionNameLower && sizeOptionIdentifiers.some(id => optionNameLower.includes(id))) { sizeOptionKey = `option${index + 1}`; return true; }
                            return false;
                        });
                        for (const variant of product.variants) {
                            if (variant.available) {
                                let variantSizeValue = null;
                                if (sizeOptionKey && variant[sizeOptionKey]) { variantSizeValue = variant[sizeOptionKey]; }
                                else {
                                    if (variant.option1?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option1;
                                    else if (variant.option2?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option2;
                                    else if (variant.option3?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option3;
                                }
                                if (variantSizeValue && String(variantSizeValue).trim() === String(targetSize).trim()) { hasTargetSize = true; break; }
                            }
                        }
                    }
                    return { productData: product, hasTargetSizeAvailable: hasTargetSize };
                });
                productsWithAvailabilityMarked.sort((a, b) => {
                    if (a.hasTargetSizeAvailable && !b.hasTargetSizeAvailable) return -1;
                    if (!a.hasTargetSizeAvailable && b.hasTargetSizeAvailable) return 1;
                    return 0;
                });
                productsToDisplayMapped = productsWithAvailabilityMarked;
            }
            logDebug(`Found ${productsToDisplayMapped.length} products to display in popup.`);
            loader.style.display = 'none';
            if (productsToDisplayMapped.length > 0) {
                renderProductGrid(productsToDisplayMapped, targetSize, status);
                grid.style.display = 'grid'; emptyMsg.style.display = 'none';
            } else {
                grid.style.display = 'none';
                let emptyMessageText = `Nenhum produto encontrado nesta coleção.`;
                if (!SHOW_ALL_PRODUCTS_IN_SIZE_POPUP) { emptyMessageText = `Nenhum produto encontrado para o Tam. ${targetSize} nesta coleção.`; }
                emptyMsg.textContent = emptyMessageText; emptyMsg.style.display = 'block'; emptyMsg.style.color = '#888';
            }
        } catch (error) {
            console.error("Error fetching or processing products for popup:", error);
            if (loader) loader.style.display = 'none';
            if (grid) grid.style.display = 'none';
            if (emptyMsg) { emptyMsg.textContent = "Erro ao carregar produtos."; emptyMsg.style.display = 'block'; emptyMsg.style.color = 'red'; }
        }
    }

    function filterProductsForSize(products, targetSize) {
        const matching = [];
        const sizeOptionIdentifiers = ['tamanho', 'size', 'shoe size', 'talla', 'eu size'];
        const normalizedTargetSize = String(targetSize).trim();
        products.forEach(product => {
            if (!product?.variants?.length) { logDebug(`Product ${product.handle} skipped: No variants.`); return; }
            let sizeOptionKey = null; let identifiedSizeOptionName = '';
            product.options?.find((opt, index) => {
                const optionNameLower = opt?.name?.toLowerCase().trim();
                if (optionNameLower && sizeOptionIdentifiers.some(id => optionNameLower.includes(id))) { sizeOptionKey = `option${index + 1}`; identifiedSizeOptionName = opt.name; return true; }
                return false;
            });
            if (!sizeOptionKey) { logDebug(`Product ${product.handle} (${product.title}): Could not identify size option from names:`, product.options?.map(o => o.name)); }
            else { logDebug(`Product ${product.handle}: Identified size option as '${identifiedSizeOptionName}' (maps to ${sizeOptionKey}).`); }
            let hasTargetSizeAvailable = false; const availableSizesInProduct = new Set();
            product.variants.forEach(variant => {
                let variantSizeValue = null;
                if (sizeOptionKey && variant[sizeOptionKey] !== undefined && variant[sizeOptionKey] !== null) { variantSizeValue = variant[sizeOptionKey]; }
                else {
                    if (variant.option1?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option1;
                    else if (variant.option2?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option2;
                    else if (variant.option3?.match(/^\s*[\d\.\/,\-]/)) variantSizeValue = variant.option3;
                    if (variantSizeValue && !sizeOptionKey) { logDebug(`Product ${product.handle}, Variant ${variant.id}: Fell back to checking option1/2/3 values directly for size. Found: ${variantSizeValue}`); }
                }
                if (variantSizeValue !== null && variantSizeValue !== undefined) {
                    const cleanedVariantSize = String(variantSizeValue).trim();
                    if (variant.available) {
                        availableSizesInProduct.add(cleanedVariantSize);
                        if (cleanedVariantSize === normalizedTargetSize) { hasTargetSizeAvailable = true; }
                    } else { if (cleanedVariantSize === normalizedTargetSize) { logDebug(`Product ${product.handle}, Variant ${variant.id}: Target size ${normalizedTargetSize} exists but variant is OOS.`); } }
                } else { logDebug(`Product ${product.handle}, Variant ${variant.id}: Could not determine a size value. Options: ${variant.option1}, ${variant.option2}, ${variant.option3}`); }
            });
            if (hasTargetSizeAvailable) { logDebug(`Product ${product.handle} MATCHED: Target size ${normalizedTargetSize} is available. All available sizes for this product:`, Array.from(availableSizesInProduct)); matching.push({ productData: product, availableSizes: availableSizesInProduct, hasTargetSizeAvailable: true }); }
        });
        return matching;
    }

    async function renderProductGrid(productsToDisplay, targetSizeFromClick, status = 'ideal') {
        const gridContainer = document.getElementById('product-size-popup-grid');
        const emptyMsg = document.getElementById('product-size-popup-empty');
        const loader = document.getElementById('calc-loading-indicator');

        if (!gridContainer) {
            console.warn("renderProductGrid: No grid container found.");
            if (loader) loader.style.display = 'none';
            return;
        }

        gridContainer.innerHTML = '';
        if (emptyMsg) emptyMsg.style.display = 'none';

        if (!productsToDisplay || productsToDisplay.length === 0) {
            logDebug("renderProductGrid: productsToDisplay is empty or null.");
            if (emptyMsg) {
                let emptyMessageText = `Nenhum produto para exibir.`;
                if (!SHOW_ALL_PRODUCTS_IN_SIZE_POPUP) {
                    emptyMessageText = `Nenhum produto encontrado para o Tam. ${targetSizeFromClick} nesta coleção.`;
                }
                emptyMsg.textContent = emptyMessageText;
                emptyMsg.style.display = 'block';
            }
            if (loader) loader.style.display = 'none';
            return;
        }

        productsToDisplay.forEach(productInfo => {
            const productData = productInfo.productData;
            if (!productData) return;

            // This variable is the key: it's true only if the size the user clicked is in stock for this product.
            const hasTargetSizeAvailable = productInfo.hasTargetSizeAvailable === true;

            const productUrl = `/products/${productData.handle}`;
            let imageUrl = productData.images?.[0]?.src || 'https://cdn.shopify.com/s/files/1/0273/9175/4340/files/placeholder.png';
            let variantIdForLink = null;
            const originalProductTitle = productData.title || 'Produto Sem Título';
            let displayTitle = originalProductTitle;

            const styleOptionNameLower = "estilo do calçado";
            let styleOptionIndex = -1;
            productData.options?.find((opt, index) => { if (opt?.name?.toLowerCase() === styleOptionNameLower) { styleOptionIndex = index; return true; } return false; });
            if (styleOptionIndex !== -1) {
                const variantForTitle = productData.variants.find(v => v.available && String(v.options?.[styleOptionIndex]).trim()) || productData.variants.find(v => v.available);
                if (variantForTitle) {
                    let styleValue = null;
                    if (styleOptionIndex === 0) styleValue = variantForTitle.option1;
                    else if (styleOptionIndex === 1) styleValue = variantForTitle.option2;
                    else if (styleOptionIndex === 2) styleValue = variantForTitle.option3;
                    if (styleValue && typeof styleValue === 'string' && styleValue.trim()) { displayTitle = styleValue.trim(); }
                }
            }
            if (!displayTitle) { displayTitle = 'Produto Sem Título'; }

            const targetVariantData = productData.variants.find(v => {
                if (!v.available) return false;
                let sizeVal = null;
                let sizeIdx = productData.options?.findIndex(opt => opt?.name?.toLowerCase().includes('tamanho')) ?? -1;
                if (sizeIdx !== -1) {
                    if (sizeIdx === 0) sizeVal = v.option1;
                    else if (sizeIdx === 1) sizeVal = v.option2;
                    else if (sizeIdx === 2) sizeVal = v.option3;
                } else {
                    if (v.option1?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) sizeVal = v.option1;
                    else if (v.option2?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) sizeVal = v.option2;
                    else if (v.option3?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) sizeVal = v.option3;
                }
                return String(sizeVal).trim() === String(targetSizeFromClick).trim();
            });
            if (targetVariantData) {
                variantIdForLink = targetVariantData.id;
                if (targetVariantData.featured_image?.src) { imageUrl = targetVariantData.featured_image.src; }
                else if (targetVariantData.image_id && productData.images) { const img = productData.images.find(i => i.id === targetVariantData.image_id); if (img?.src) imageUrl = img.src; }
            }
            const finalLinkUrl = variantIdForLink ? `${productUrl}?variant=${variantIdForLink}` : productUrl;

            // 1. Get all sizes and their availability for this specific product.
            const productSpecificVariantSizes = new Map();
            let productSizeOptionKey = null;
            productData.options?.find((opt, index) => {
                const optionNameLower = opt?.name?.toLowerCase();
                const sizeOptionIdentifiers = ['tamanho', 'size', 'shoe size', 'talla'];
                if (optionNameLower && sizeOptionIdentifiers.some(id => optionNameLower.includes(id))) {
                    productSizeOptionKey = `option${index + 1}`;
                    return true;
                }
                return false;
            });

            productData.variants.forEach(variant => {
                let vSizeVal = null;
                if (productSizeOptionKey && variant[productSizeOptionKey]) {
                    vSizeVal = variant[productSizeOptionKey];
                } else {
                    if (variant.option1?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) vSizeVal = variant.option1;
                    else if (variant.option2?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) vSizeVal = variant.option2;
                    else if (variant.option3?.match(/^\s*[\d\.\/,\-smlxlXSMLXL]/i)) vSizeVal = variant.option3;
                }

                if (vSizeVal) {
                    const cleanedVSize = String(vSizeVal).trim();
                    if (!productSpecificVariantSizes.has(cleanedVSize) || variant.available) {
                        productSpecificVariantSizes.set(cleanedVSize, { available: variant.available });
                    }
                }
            });

            // 2. Create the size ruler from this product's specific sizes.
            const productSizeRuler = sortSizesNumerically(Array.from(productSpecificVariantSizes.keys()));
            let sizeListHtml = productSizeRuler.map(rulerSize => {
                let itemClass = 'size-item';
                const variantInfo = productSpecificVariantSizes.get(rulerSize);
                const isTargetSize = rulerSize === String(targetSizeFromClick).trim();

                if (variantInfo) {
                    if (variantInfo.available) {
                        if (isTargetSize) {
                            itemClass += ' target-size-item';
                            if (status === 'marginWarning') {
                                itemClass += ' target-size-item-warning';
                            }
                        } else {
                            itemClass += ' size-available-other';
                        }
                    } else {
                        itemClass += ' size-unavailable';
                    }
                }

                return `<span class="${itemClass}" title="Tamanho ${rulerSize}">${rulerSize}</span>`;
            }).join('');

            // 3. Create the card and apply the yellow class IF THE TARGET SIZE IS NOT AVAILABLE.
            const card = document.createElement('div');
            card.className = 'product-item-card';

            if (!hasTargetSizeAvailable) {
                card.classList.add('product-card-no-stock');
                card.title = `O tamanho ${targetSizeFromClick} não está disponível para este modelo.`;
            }

            card.innerHTML = `
            <a href="${finalLinkUrl}" target="_blank" rel="noopener" title="${displayTitle}">
                <img src="${imageUrl}" alt="${displayTitle}" class="popup-product-image" loading="lazy">
                <div class="product-title">${displayTitle}</div>
                <div class="product-price-container">
                    ${getPriceHtml(targetVariantData || productData.variants[0])}
                </div>
            </a>
            <div class="product-size-info scrollable-sizes">
                 ${sizeListHtml || '<span class="size-item size-unavailable">N/A</span>'}
            </div>
        `;
            gridContainer.appendChild(card);

            const scrollableContainer = card.querySelector('.scrollable-sizes');
            const targetElementToScroll = card.querySelector('.target-size-item');
            if (scrollableContainer && targetElementToScroll) {
                setTimeout(() => {
                    try {
                        const containerRect = scrollableContainer.getBoundingClientRect();
                        const targetRect = targetElementToScroll.getBoundingClientRect();
                        const scrollAdjustment = (targetRect.left + targetRect.width / 2) - (containerRect.left + containerRect.width / 2);
                        let newScrollLeft = scrollableContainer.scrollLeft + scrollAdjustment;
                        newScrollLeft = Math.max(0, Math.min(newScrollLeft, scrollableContainer.scrollWidth - scrollableContainer.clientWidth));
                        if (Math.abs(scrollableContainer.scrollLeft - newScrollLeft) > 1) {
                            scrollableContainer.scrollLeft = newScrollLeft;
                        }
                    } catch (scrollErr) {
                        console.warn("Error scrolling target size into view:", scrollErr, targetElementToScroll);
                    }
                }, 150);
            }
        });

        if (loader) loader.style.display = 'none';
        applyDragToScroll();
    }

    /**
     * Helper to generate Price HTML
     */
    function getPriceHtml(variant) {
        if (!variant) return '';

        // Shopify prices are usually strings like "29.95" or numbers. 
        // We want to format them as currency.
        // NOTE: This assumes EUR as per the context of the site (gotu.pt).

        const price = parseFloat(variant.price);
        const comparePrice = parseFloat(variant.compare_at_price);

        if (isNaN(price)) return '';

        const formatPrice = (val) => {
            return val.toFixed(2).replace('.', ',') + ' €';
        };

        if (!isNaN(comparePrice) && comparePrice > price) {
            return `<span class="original-price">${formatPrice(comparePrice)}</span><span class="product-price on-sale">${formatPrice(price)}</span>`;
        } else {
            return `<span class="product-price">${formatPrice(price)}</span>`;
        }
    }

    // --------- WARNING GENERATION -----------
    function generateWarningCases(sizeMap, marginLogic, measurement, absMinFoot = 70, absMaxFoot = 290) {
        const warnings = [];
        let effectiveMinMargin = marginLogic.minMargin; let effectiveMaxMargin = marginLogic.maxMargin;
        if (marginLogic.threshold && measurement > marginLogic.threshold) {
            if (marginLogic.altMinMargin !== undefined) { effectiveMinMargin = marginLogic.altMinMargin; }
            if (marginLogic.altMaxMargin !== undefined) { effectiveMaxMargin = marginLogic.altMaxMargin; }
        }
        if (typeof effectiveMinMargin !== 'number' || typeof effectiveMaxMargin !== 'number') { console.error("Invalid effective margins in generateWarningCases", marginLogic); return []; }
        if (!sizeMap || typeof sizeMap !== 'object' || !Object.keys(sizeMap).length) return [];
        const innerSoles = Object.keys(sizeMap).map(Number).filter(n => !isNaN(n)).sort((a, b) => a - b);
        if (!innerSoles.length) return [];
        const sizeRanges = innerSoles.map(sole => ({ sole: sole, minFoot: sole - effectiveMaxMargin, maxFoot: sole - effectiveMinMargin, displaySize: sizeMap[sole]?.size || `T ${sole}mm`, width: sizeMap[sole]?.width || "" }));
        if (sizeRanges.length > 0) {
            const smallest = sizeRanges[0]; // Gets the smallest available size

            // --- NEW ORANGE/YELLOW LEEWAY BLOCK ---
            // Define the 1cm (10mm) leeway range just below the minimum foot size
            const leewayEnd = smallest.minFoot - 1;
            const leewayStart = smallest.minFoot - 10;

            if (leewayStart <= leewayEnd) {
                warnings.push({
                    measurementMin: leewayStart,
                    measurementMax: leewayEnd,
                    display: smallest.displaySize, // Show the size they should aim for
                    width: smallest.width,
                    targetInnerSole: smallest.sole,
                    status: 'marginWarning' // This makes it ORANGE/YELLOW
                });
            }
            // --- END OF NEW BLOCK ---

            // --- ADJUSTED RED WARNING BLOCK ---
            // The red warning now starts where the orange leeway ends
            const warningMinFoot = Math.max(absMinFoot, smallest.minFoot - 9); // Buffer can remain
            const warningMaxFoot = leewayStart - 1; // ADJUSTED: Red now ends before orange begins

            if (warningMinFoot <= warningMaxFoot) {
                warnings.push({
                    measurementMin: warningMinFoot,
                    measurementMax: warningMaxFoot,
                    display: `Pé Pequeno<br>(Próximo: ${smallest.displaySize})`,
                    width: smallest.width,
                    targetInnerSole: smallest.sole,
                    status: 'rangeWarning' // This remains RED
                });
            }
        }
        for (let i = 0; i < sizeRanges.length - 1; i++) {
            const current = sizeRanges[i], next = sizeRanges[i + 1];
            const gapStart = current.maxFoot + 1; const gapEnd = next.minFoot - 1;
            if (gapStart <= gapEnd) { warnings.push({ measurementMin: gapStart, measurementMax: gapEnd, display: next.displaySize, width: next.width, targetInnerSole: next.sole, status: 'marginWarning' }); }
        }
        if (sizeRanges.length > 0) {
            const largest = sizeRanges[sizeRanges.length - 1];
            const warningMinFoot = largest.maxFoot + 1; const warningMaxFoot = absMaxFoot;
            if (warningMinFoot <= warningMaxFoot) { warnings.push({ measurementMin: warningMinFoot, measurementMax: warningMaxFoot, display: `Pé Grande<br>(Acima de: ${largest.displaySize})`, width: largest.width, targetInnerSole: null, status: 'rangeWarning' }); }
        }
        return warnings;
    }

    // --------- CORE CALCULATION LOGIC -----------
    function getMeasurementInput() {
        const input = document.getElementById("measurement"), unitSelect = document.getElementById("unit"), resultsDiv = document.getElementById("results"), actionsContainer = document.getElementById("result-actions-container"), copyButton = document.getElementById("copy-link-icon-button"), mainFilterButtonWrapper = document.getElementById('main-filter-button-wrapper');
        if (resultsDiv) try { resultsDiv.innerHTML = ""; } catch (e) { }
        if (actionsContainer) try { actionsContainer.style.display = 'none'; } catch (e) { }
        if (copyButton) try { copyButton.disabled = true; } catch (e) { }
        if (mainFilterButtonWrapper) try { mainFilterButtonWrapper.style.display = 'none'; } catch (e) { }
        if (!input) { if (resultsDiv) try { resultsDiv.innerHTML = "<p class='error'>Erro: Campo de medida em falta.</p>"; } catch (e) { } return { valid: false, element: null }; }
        if (!resultsDiv) { return { valid: false, element: input }; }
        let measurementValue = input.valueAsNumber;
        if (isNaN(measurementValue)) { try { measurementValue = parseFloat(input.value.replace(',', '.').trim()); } catch (parseError) { measurementValue = NaN; } }
        if (isNaN(measurementValue)) { if (resultsDiv) try { resultsDiv.innerHTML = "<p>Por favor, introduza um número válido para a medida.</p>"; } catch (e) { } return { valid: false, element: input }; }
        if (unitSelect && unitSelect.value === "cm") { measurementValue *= 10; }
        measurementValue = Math.round(measurementValue);
        const minFoot = 70, maxFoot = 290;
        if (measurementValue < minFoot || measurementValue > maxFoot) { if (resultsDiv) try { resultsDiv.innerHTML = `<p><h3>Medida Inválida: ${input.value}${unitSelect?.value || 'mm'} ❌</h3></p><p>A medida deve estar entre ${minFoot}mm e ${maxFoot}mm.</p>`; } catch (e) { } return { valid: false, element: input }; }
        return { valid: true, measurement: measurementValue, element: input };
    }

    function generateRowsForModule(config, measurement) {
        const rows = [];
        if (!config?.id) { console.warn("Skipping module due to missing ID:", config); return []; }
        const linkMatch = config.link?.match(/href='([^']*)'/i);
        const href = linkMatch?.[1] || '#';
        const imageUrl = config.imageUrl || '';
        const imageAlt = config.imageAlt || config.name || 'Imagem do Produto';
        const imageHtml = `<a href='${href}' target='_blank' rel='noopener'><img src='${imageUrl}' alt="${imageAlt}" class='product-image' data-module-id='${config.id}' loading='lazy'></a>`;

        if (config.calculationType === 'lookup') {
            if (!config.lookupTable?.length) return [];
            for (const entry of config.lookupTable) {
                const minVal = +entry.min;
                const maxVal = +entry.max;
                if (isNaN(minVal) || isNaN(maxVal) || !entry.size) continue;

                const matchesMin = (minVal === SENTINEL_MIN) ? true : (measurement >= minVal);
                const matchesMax = (maxVal === SENTINEL_MAX) ? true : (measurement <= maxVal);

                if (matchesMin && matchesMax) {
                    let displaySize = entry.size, status = 'ideal';
                    if (displaySize.includes("👇")) { status = 'rangeWarning'; displaySize = displaySize.replace("👇👟", "").trim() + "<br><span class='small'>(Pé Pequeno)</span>"; }
                    else if (displaySize.includes("🤚")) { status = 'rangeWarning'; displaySize = displaySize.replace("🤚🩰", "").trim() + "<br><span class='small'>(Pé Grande)</span>"; }
                    else if (displaySize.startsWith("⚠️")) { status = 'marginWarning'; displaySize = displaySize.replace("⚠️", "").trim(); }

                    let sortKeyToUse = minVal;
                    if (minVal === SENTINEL_MIN && status !== 'rangeWarning') { sortKeyToUse = measurement - 1000; }
                    else if (minVal === SENTINEL_MIN && displaySize.includes("👇")) { sortKeyToUse = -Infinity; } // Actual -Infinity for sorting

                    rows.push({ size: displaySize, link: config.link, image: imageHtml, width: entry.width || "", status: status, moduleId: config.id, brand: config.brand, sortKey: sortKeyToUse });
                    break;
                }
            }
        }
        else if (config.calculationType === 'margin') {
            if (!config.sizeMap || typeof config.sizeMap !== 'object') return [];
            const logic = { base: 8, length: 4, minMargin: 8, maxMargin: 11, ...config.marginLogic };
            const { base, length, minMargin, maxMargin, threshold, altBase, altLength, altMinMargin, altMaxMargin } = logic;
            let currentBase = base, currentLength = length, currentMinMargin = minMargin, currentMaxMargin = maxMargin;
            if (threshold && measurement > threshold) {
                if (altBase !== undefined) currentBase = altBase;
                if (altLength !== undefined) currentLength = altLength;
                if (altMinMargin !== undefined) currentMinMargin = altMinMargin;
                if (altMaxMargin !== undefined) currentMaxMargin = altMaxMargin;
            }
            if (typeof currentBase !== 'number' || typeof currentLength !== 'number' || typeof currentMinMargin !== 'number' || typeof currentMaxMargin !== 'number') { console.error(`Invalid effective marginLogic for module ${config.id}`); return []; }
            const targetStartSole = measurement + currentBase;
            const potentialSoles = Array.from({ length: Math.max(0, currentLength) }, (_, i) => targetStartSole + i);
            potentialSoles.forEach(sole => {
                if (config.sizeMap.hasOwnProperty(sole)) {
                    const sizeData = config.sizeMap[sole]; if (!sizeData?.size) return;
                    const actualMargin = sole - measurement;
                    if (actualMargin >= currentMinMargin && actualMargin <= currentMaxMargin) {
                        const marginText = `<br><div class="margin-text margin-ideal">Margem:<br>${actualMargin}mm</div>`;
                        rows.push({ size: sizeData.size + marginText, link: config.link, image: imageHtml, width: sizeData.width || "", status: 'ideal', moduleId: config.id, brand: config.brand, sortKey: sole });
                    }
                }
            });
            const warningCases = config.warningCases || generateWarningCases(config.sizeMap, logic, measurement);
            if (warningCases?.length) {
                const addedWarningStatus = new Set();
                for (const warning of warningCases) {
                    if (measurement >= warning.measurementMin && measurement <= warning.measurementMax) {
                        if (addedWarningStatus.has(warning.status)) continue;
                        const warningBaseSizeText = extractBaseSizeText(warning.display || "");
                        const isIdealAlreadyPresentForThisSize = rows.some(r => {
                            if (r.status !== 'ideal') return false;
                            const idealBaseSizeText = extractBaseSizeText(r.size || "");
                            return idealBaseSizeText === warningBaseSizeText;
                        });
                        if ((warning.status === 'marginWarning' || warning.status === 'rangeWarning') && isIdealAlreadyPresentForThisSize) {
                            logDebug(`Skipping ${warning.status} for size '${warningBaseSizeText}' as ideal exists for module ${config.id}.`);
                            continue;
                        }
                        let marginText = "";
                        if (warning.targetInnerSole != null) {
                            const calculatedMargin = warning.targetInnerSole - measurement;
                            if (calculatedMargin >= 0) {
                                const marginClass = warning.status === 'rangeWarning' ? "margin-warning-range" : "margin-warning";
                                marginText = `<br><div class="margin-text ${marginClass}">Margem:<br>${calculatedMargin}mm</div>`;
                            }
                        }
                        const prefix = warning.status === 'rangeWarning' ? "❌ " : "⚠️ ";

                        let marginTextToDisplay = marginText;
                        if (marginTextToDisplay) {
                            marginTextToDisplay = marginTextToDisplay.replace(/Margem:/i, "Espaço extra:");
                        }

                        rows.push({ size: prefix + (warning.display || "") + marginTextToDisplay, link: config.link, image: imageHtml, width: warning.width || "", status: warning.status, moduleId: config.id, brand: config.brand, sortKey: warning.measurementMin });
                        addedWarningStatus.add(warning.status);
                    }
                }
            }
        }
        else if (config.calculationType === 'special' && config.id === 'meias') {
            if (!config.imageUrls?.length) return [];
            const meiasImageHtml = `<a href='${href}' target='_blank' rel='noopener'><img src='${config.imageUrls[0]}' alt="${imageAlt || 'Meias'}" id='meias-img-rotator' class='product-image' loading='lazy'></a>`;
            rows.push({ size: "", link: config.link, image: meiasImageHtml, width: "", status: 'ideal', isMeias: true, moduleId: config.id, brand: config.brand, sortKey: Infinity });
        }
        const uniqueRows = []; const seenKeys = new Set();
        for (const row of rows) {
            const sizeBase = typeof row.size === 'string' ? row.size.split('<br>')[0].replace(/^[✅⚠️❌❗👇👟🤚🩰]\s*/, '').trim() : String(row.size);
            const key = `${sizeBase}-${row.link}-${row.width}-${row.status}-${row.moduleId}`;
            if (!seenKeys.has(key)) { uniqueRows.push(row); seenKeys.add(key); }
        }
        return uniqueRows;
    }



    // --------- RENDERING -----------
    function renderTable(rows) {
        const resultsDiv = document.getElementById("results"), saveActions = document.getElementById("result-actions-container"), copyBtn = document.getElementById("copy-link-icon-button");
        if (!resultsDiv || !saveActions || !copyBtn) { console.error("RenderTable: Missing essential elements."); return null; }
        resultsDiv.innerHTML = "";
        if (!rows?.length) { if (resultsDiv) resultsDiv.innerHTML = "<p>Nenhum modelo encontrado para esta medida e filtro.</p>"; if (saveActions) saveActions.style.display = 'none'; if (copyBtn) copyBtn.disabled = true; return null; }
        const idealH = "✅ Tamanhos Recomendados", marginH = "⚠️ Outras Opções (Espaço Extra Menor/Maior)", rangeH = "❌ Tamanhos Não Recomendados";
        const headerHtml = `<thead class='my-table-header'><tr><th>Tam.</th><th style="white-space: nowrap;">Marca &<br>Variante</th><th>Modelo</th><th>Larg.</th></tr></thead>`;
        let idealSectionHtml = "", marginSectionHtml = "", rangeSectionHtml = "";
        rows.forEach((row) => {
            if (!row?.status || !row.moduleId) { console.warn("Skipping row due to missing status or moduleId:", row); return; }
            const rowCls = `data-row ${row.status !== 'ideal' ? 'warning' : 'normal'}${row.isMeias ? ' meias' : ''}`;
            let displaySize = row.size || ''; let sizeCellAttrs = '';
            if ((row.status === 'ideal' || row.status === 'marginWarning') && !row.isMeias && typeof displaySize === 'string') {
                const baseSizeText = extractBaseSizeText(displaySize);
                if (baseSizeText && isTwoDigitNumberString(baseSizeText)) { sizeCellAttrs = ` class="clickable-size" data-size="${baseSizeText}"`; }
            }
            let brandCellHtml = row.link || '';
            const linkMatch = typeof row.link === 'string' ? row.link.match(/<a href='([^']*)'[^>]*>(.*?)<\/a>/i) : null;
            const href = linkMatch?.[1] || '#'; const target = linkMatch && row.link.includes('target="_blank"') ? '_blank' : ''; const rel = target === '_blank' ? 'noopener' : '';
            const innerLinkHtml = linkMatch?.[2] || ''; const tempDiv = document.createElement('div'); tempDiv.innerHTML = innerLinkHtml; const linkText = (tempDiv.textContent || '').trim();
            if (SHOW_LOGOS_INSTEAD_OF_NAME && BRAND_LOGOS && !row.isMeias && row.brand && BRAND_LOGOS[row.brand.toLowerCase()]) {
                const logoUrl = BRAND_LOGOS[row.brand.toLowerCase()];
                const variantText = linkText.replace(new RegExp(row.brand + ':?\\s*', 'i'), '').trim();
                brandCellHtml = `<a href='${href}' ${target ? `target='${target}'` : ''} ${rel ? `rel='${rel}'` : ''}><img src="${logoUrl}" alt="${row.brand}" class="brand-logo-in-table" loading="lazy"><span class="variant-in-table">${variantText}</span></a>`;
            } else if (linkMatch) { brandCellHtml = `<a href='${href}' ${target ? `target='${target}'` : ''} ${rel ? `rel='${rel}'` : ''}>${innerLinkHtml}</a>`; }
            else { brandCellHtml = row.link || linkText; }
            let imageCellHtml = row.image || '';
            if (typeof imageCellHtml === 'string' && imageCellHtml.includes('<a href') && !row.isMeias) {
                if (!imageCellHtml.includes('target="_blank"')) imageCellHtml = imageCellHtml.replace(/<a\s+href=/i, '<a target="_blank" href=');
                if (!imageCellHtml.includes('rel="noopener"')) imageCellHtml = imageCellHtml.replace(/<a\s+/i, '<a rel="noopener" ');
            }
            const rowHtml = `<tr class='${rowCls}' data-module-id='${row.moduleId}' data-status='${row.status}'> <td${sizeCellAttrs}>${displaySize}</td> <td>${brandCellHtml}</td> <td>${imageCellHtml}</td> <td>${row.width || ''}</td> </tr>`;
            switch (row.status) { case 'ideal': idealSectionHtml += rowHtml; break; case 'marginWarning': marginSectionHtml += rowHtml; break; case 'rangeWarning': rangeSectionHtml += rowHtml; break; default: marginSectionHtml += rowHtml; break; }
        });
        const currentInputField = document.getElementById("measurement");
        const currentMeasurement = currentInputField ? currentInputField.value.trim() : "";
        let tableHtml = "";

        if (currentMeasurement) {
            tableHtml += `<p style="text-align: center; margin-bottom: 20px; font-weight: bold; font-size: 1.2rem;">Para um pé de ${currentMeasurement}mm, recomendamos as seguintes opções:</p>`;
        }

        tableHtml += "<table class='my-table'>";
        if (idealSectionHtml) tableHtml += `<thead class='my-table-ideal'><tr class='section-header'><th colspan='4'>${idealH}</th></tr></thead>${headerHtml}<tbody class='ideal-section'>${idealSectionHtml}</tbody>`;
        if (marginSectionHtml) tableHtml += `<thead class='my-table-margin-warn'><tr class='section-header'><th colspan='4'>${marginH}</th></tr></thead>${headerHtml}<tbody class='margin-warn-section'>${marginSectionHtml}</tbody>`;
        if (rangeSectionHtml) tableHtml += `<thead class='my-table-range-warn'><tr class='section-header'><th colspan='4'>${rangeH}</th></tr></thead>${headerHtml}<tbody class='range-warn-section'>${rangeSectionHtml}</tbody>`;
        tableHtml += "</table>";

        // Add the explanatory legend
        tableHtml += `
        <div class="calculator-legend-cards">
            <h4 class="legend-title-cards">Como ler os resultados?</h4>
            <ul class="legend-list-cards">
                <li class="legend-item-card">
                    <span class="legend-icon-card icon-ideal-card">✅</span>
                    <span class="legend-text-card"><strong>Tamanhos Recomendados:</strong> Crescimento ideal garantido.</span>
                </li>
                <li class="legend-item-card">
                    <span class="legend-icon-card icon-warning-card">⚠️</span>
                    <span class="legend-text-card"><strong>Outras Opções:</strong> Espaço extra ligeiramente acima ou abaixo do recomendado.</span>
                </li>
                <li class="legend-item-card">
                    <span class="legend-icon-card icon-range-warning-card">❌</span>
                    <span class="legend-text-card"><strong>Não Recomendados:</strong> Medida fora do intervalo seguro.</span>
                </li>
            </ul>
        </div>
        `;

        try { resultsDiv.innerHTML = tableHtml; } catch (e) { console.error("Error setting table HTML:", e); try { resultsDiv.innerHTML = "<p class='error'>Erro ao construir tabela.</p>"; } catch (re) { } return null; }
        try { const tableBodyRows = resultsDiv.querySelectorAll('.my-table tbody tr'); tableBodyRows.forEach((row, index) => { row.style.animationDelay = `${index * 0.05}s`; }); } catch (e) { console.error("Error applying row animation delays:", e); }
        try { saveActions.style.display = 'flex'; copyBtn.disabled = false; } catch (e) { console.error("Error enabling action buttons:", e); }
        return resultsDiv.querySelector('table');
    }

    // --------- HELPER FUNCTIONS -----------
    function disableButton(duration = 1500) {
        const btn = document.getElementById("calc-button1"); if (!btn || btn.disabled) return;
        let originalHTML = btn.innerHTML;
        try { btn.disabled = true; btn.style.opacity = '0.6'; btn.style.cursor = 'not-allowed'; btn.innerHTML = 'A Calcular... <span class="button-spinner"></span>'; }
        catch (e) { if (btn) { try { btn.innerHTML = originalHTML; btn.disabled = false; btn.style.opacity = '1'; btn.style.cursor = 'pointer'; } catch (restoreError) { } } return; }
        setTimeout(() => {
            const currentBtn = document.getElementById("calc-button1");
            if (currentBtn) { try { currentBtn.disabled = false; currentBtn.style.opacity = '1'; currentBtn.style.cursor = 'pointer'; currentBtn.innerHTML = originalHTML; } catch (e) { if (currentBtn) try { currentBtn.textContent = 'Calcular'; } catch (textErr) { } } }
        }, duration);
    }

    function startMeiasImageRotation() {
        if (meiasIntervalId !== null) { try { clearInterval(meiasIntervalId); } catch (e) { } meiasIntervalId = null; }
        try {
            const imgElement = document.getElementById('meias-img-rotator');
            const meiasConfig = MODULE_CONFIGS.find(m => m.id === 'meias'); // Use loaded MODULE_CONFIGS
            if (!imgElement || !meiasConfig?.imageUrls?.length || meiasConfig.imageUrls.length <= 1) {
                if (imgElement && meiasConfig?.imageUrls?.length >= 1) { try { imgElement.src = meiasConfig.imageUrls[0]; } catch (e) { } } return;
            }
            let currentImageIndex = 0; try { imgElement.src = meiasConfig.imageUrls[0]; } catch (e) { return; }
            meiasIntervalId = setInterval(() => {
                if (!document.body.contains(imgElement)) { try { clearInterval(meiasIntervalId); } catch (e) { } meiasIntervalId = null; return; }
                currentImageIndex = (currentImageIndex + 1) % meiasConfig.imageUrls.length;
                try { imgElement.src = meiasConfig.imageUrls[currentImageIndex]; }
                catch (e) { try { clearInterval(meiasIntervalId); } catch (ce) { } meiasIntervalId = null; }
            }, 3000);
        } catch (e) { if (meiasIntervalId) { try { clearInterval(meiasIntervalId); } catch (ce) { } meiasIntervalId = null; } }
    }

    // --------- ASYNC ENHANCEMENTS -----------
    async function fetchCollectionProducts(handle) {
        if (productsCache.has(handle)) {
            return productsCache.get(handle);
        }
        if (activeFetchPromises.has(handle)) {
            return activeFetchPromises.get(handle);
        }
        const promise = (async () => {
            const response = await fetch(`/collections/${handle}/products.json?limit=250&fields=variants,options,handle`);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            productsCache.set(handle, data);
            return data;
        })();
        activeFetchPromises.set(handle, promise);
        
        promise.catch(() => {}).finally(() => {
            activeFetchPromises.delete(handle);
        });
        
        return promise;
    }

    async function addAsyncEnhancements(tableElement) {
        if (!tableElement) return;
        const loadingIndicator = document.getElementById('calc-loading-indicator');
        if (loadingIndicator) { try { loadingIndicator.innerHTML = '<div class="loader-spinner"></div>'; loadingIndicator.style.display = 'block'; } catch (e) { } }
        startMeiasImageRotation();
        try { await Promise.allSettled([checkCollectionSales(tableElement).catch(e => console.error("Sales check rejected:", e)), checkSizeAvailability(tableElement).catch(e => console.error("Availability check rejected:", e))]); }
        catch (error) { console.error("Error during async enhancement execution:", error); }
        finally { if (loadingIndicator) { try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (e) { } } }
    }

    async function checkCollectionSales(containerElement) {
        if (!containerElement) return;
        const collectionLinks = Array.from(containerElement.querySelectorAll('td:nth-child(2) a[href*="/collections/"]:not(:has(.sale-badge))'));
        const collectionHandles = new Set(); const linksByHandle = {};
        collectionLinks.forEach(link => {
            try {
                const url = new URL(link.href, window.location.origin);
                const handle = url.pathname.split('/collections/')[1]?.split(/[\/\?#]/)[0];
                if (handle) { collectionHandles.add(handle); if (!linksByHandle[handle]) linksByHandle[handle] = []; linksByHandle[handle].push(link); }
            } catch (e) { }
        });
        if (!collectionHandles.size) { return; }
        
        let staggerIndex = 0;
        await Promise.all(Array.from(collectionHandles).map(async handle => {
            const myIndex = staggerIndex++;
            try {
                let maxDiscount = 0;
                if (saleCache.has(handle)) { maxDiscount = saleCache.get(handle); }
                else {
                    await new Promise(resolve => setTimeout(resolve, myIndex * 150));
                    const data = await fetchCollectionProducts(handle);
                    if (data?.products) {
                        maxDiscount = data.products.reduce((maxOverall, product) => {
                            let productMax = 0;
                            product.variants?.forEach(variant => {
                                const originalPrice = +variant.compare_at_price, currentPrice = +variant.price;
                                if (!isNaN(originalPrice) && !isNaN(currentPrice) && originalPrice > currentPrice && originalPrice > 0) { productMax = Math.max(productMax, Math.round(((originalPrice - currentPrice) / originalPrice) * 100)); }
                            });
                            return Math.max(maxOverall, productMax);
                        }, 0);
                    }
                    saleCache.set(handle, maxDiscount);
                }
                if (maxDiscount > 0 && linksByHandle[handle]) { linksByHandle[handle].forEach(linkElement => addSaleBadge(linkElement, maxDiscount)); }
            } catch (error) { saleCache.set(handle, 0); }
        }));
    }
    function addSaleBadge(linkElement, discount) {
        try {
            const cell = linkElement.closest('td'); if (!cell || cell.querySelector('.sale-badge')) return;
            const badge = document.createElement('div'); badge.className = 'sale-badge gotuPulseAnimation';
            badge.innerHTML = `🏷️ Até ${discount}% desconto!`; cell.appendChild(badge);
        } catch (e) { }
    }
    async function checkSizeAvailability(containerElement) {
        if (!containerElement) return;
        const idealRows = Array.from(containerElement.querySelectorAll('tr.data-row[data-status="ideal"]:not(.meias):not(:has(.size-unavailable-message))'));
        if (!idealRows.length) { return; }
        const rowsByHandle = {}; const handlesToCheck = new Set();
        idealRows.forEach(rowElement => {
            try {
                const sizeCell = rowElement.querySelector('td:first-child'); const linkElement = rowElement.querySelector('td:nth-child(2) a[href*="/collections/"]');
                if (!sizeCell || !linkElement) return;
                const baseSizeText = extractBaseSizeText(sizeCell.innerHTML);
                if (baseSizeText && isTwoDigitNumberString(baseSizeText)) {
                    let handle = '';
                    try { const url = new URL(linkElement.href, window.location.origin); handle = url.pathname.split('/collections/')[1]?.split(/[\/\?#]/)[0]; }
                    catch (e) { return; }
                    if (!handle) { return; }
                    handlesToCheck.add(handle); if (!rowsByHandle[handle]) rowsByHandle[handle] = [];
                    rowsByHandle[handle].push({ row: rowElement, recommendedSize: baseSizeText });
                }
            } catch (e) { }
        });
        if (!handlesToCheck.size) { return; }
        
        let staggerIndex = 0;
        await Promise.all(Array.from(handlesToCheck).map(async handle => {
            const myIndex = staggerIndex++;
            let availableSizes = new Set();
            try {
                if (sizeAvailabilityCache.has(handle)) { availableSizes = sizeAvailabilityCache.get(handle); }
                else {
                    await new Promise(resolve => setTimeout(resolve, myIndex * 150));
                    const data = await fetchCollectionProducts(handle);
                    const foundSizes = new Set();
                    if (data?.products) {
                        data.products.forEach(product => {
                            let sizeOptionIndex = -1; const sizeIdentifier = 'tamanho';
                            product.options?.find((opt, index) => { if (opt?.name?.toLowerCase().includes(sizeIdentifier)) { sizeOptionIndex = index; return true; } return false; });
                            product.variants?.forEach(variant => {
                                if (!variant?.available) return; let sizeValue = null;
                                if (sizeOptionIndex !== -1 && variant.options?.[sizeOptionIndex]) { sizeValue = variant.options[sizeOptionIndex]; }
                                else { if (variant.option1?.match(/^\s*[\d\.\/,\-]/)) sizeValue = variant.option1; else if (variant.option2?.match(/^\s*[\d\.\/,\-]/)) sizeValue = variant.option2; else if (variant.option3?.match(/^\s*[\d\.\/,\-]/)) sizeValue = variant.option3; }
                                if (sizeValue) foundSizes.add(sizeValue.toString().trim());
                            });
                        });
                    }
                    sizeAvailabilityCache.set(handle, foundSizes); availableSizes = foundSizes;
                }
                if (rowsByHandle[handle]) { rowsByHandle[handle].forEach(({ row, recommendedSize }) => { if (!availableSizes.has(recommendedSize)) { addSizeNotAvailableMessage(row, recommendedSize); } }); }
            } catch (error) { sizeAvailabilityCache.set(handle, new Set()); }
        }));
    }
    function addSizeNotAvailableMessage(row, missingSize) {
        try {
            const cell = row.querySelector('td:nth-child(2)'); if (!cell || cell.querySelector('.size-unavailable-message')) return;
            const messageDiv = document.createElement('div'); messageDiv.className = 'size-unavailable-message';
            messageDiv.innerHTML = `❗ Sem stock Tam. ${missingSize} ❗`; cell.appendChild(messageDiv);
        } catch (e) { }
    }

    // --------- MAIN ORCHESTRATION FUNCTION (calculateSizes already defined above) -----------
    function calculateSizes() {
        // Critical check: Ensure configurations are loaded before proceeding
        if (!isConfigLoaded || !MODULE_CONFIGS || !MODULE_CONFIGS.length === 0) {
            console.error("calculateSizes FATAL: MODULE_CONFIGS are not loaded or are empty. Cannot perform calculation.");
            const resultsDiv = document.getElementById("results");
            if (resultsDiv) {
                try { resultsDiv.innerHTML = "<p class='error'>Erro: Dados de configuração não disponíveis. Recarregue a página (E05).</p>"; } catch (e) { }
            }
            // Hide loading and action elements if they were shown
            const loadingIndicator = document.getElementById('calc-loading-indicator');
            if (loadingIndicator) try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (e) { }
            const actionsContainer = document.getElementById("result-actions-container");
            if (actionsContainer) try { actionsContainer.style.display = 'none'; } catch (e) { }
            const copyButton = document.getElementById("copy-link-icon-button");
            if (copyButton) try { copyButton.disabled = true; } catch (e) { }
            const mainFilterButtonWrapper = document.getElementById('main-filter-button-wrapper');
            if (mainFilterButtonWrapper) try { mainFilterButtonWrapper.style.display = 'none'; } catch (e) { }
            // NEW: Also hide results controls
            const controlsContainer = document.getElementById('results-controls');
            if (controlsContainer) try { controlsContainer.style.display = 'none'; } catch (e) { }
            return; // Stop calculation
        }

        logDebug("calculateSizes: Starting calculation process.");
        performance.mark('calc-start');

        const loadingIndicator = document.getElementById('calc-loading-indicator');
        const resultsDiv = document.getElementById("results");
        const actionsContainer = document.getElementById("result-actions-container");
        const copyButton = document.getElementById("copy-link-icon-button");
        const mainFilterButtonWrapper = document.getElementById('main-filter-button-wrapper');
        // NEW: Get the new controls container
        const controlsContainer = document.getElementById('results-controls');

        // Show main loading spinner and reset all UI elements
        if (loadingIndicator) { try { loadingIndicator.innerHTML = '<div class="loader-spinner"></div>'; loadingIndicator.style.display = 'block'; } catch (e) { } }
        if (actionsContainer) try { actionsContainer.style.display = 'none'; } catch (e) { }
        if (copyButton) try { copyButton.disabled = true; } catch (e) { }
        if (mainFilterButtonWrapper) try { mainFilterButtonWrapper.style.display = 'none'; } catch (e) { }
        // NEW: Clear and hide the controls container for the new calculation
        if (controlsContainer) { try { controlsContainer.innerHTML = ''; controlsContainer.style.display = 'none'; } catch (e) { } }
        if (resultsDiv) { try { resultsDiv.classList.add('calculating'); } catch (e) { } }
        if (meiasIntervalId) { try { clearInterval(meiasIntervalId); meiasIntervalId = null; } catch (e) { } }

        // Get and validate measurement
        const inputResult = getMeasurementInput();
        if (!inputResult.valid) {
            logDebug("calculateSizes: Input is invalid. Aborting calculation.");
            if (loadingIndicator) try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (e) { }
            if (resultsDiv) try { resultsDiv.classList.remove('calculating'); } catch (e) { }
            currentResults = []; // NEW: Clear any previous results
            return; // Stop calculation
        }

        const { measurement } = inputResult;
        const selectedFilter = getSelectedFilter();
        logDebug(`calculateSizes: Input: ${measurement}mm, Filter: ${selectedFilter}, Modules available: ${MODULE_CONFIGS.length}`);

        // Generate rows for all applicable modules
        let allRows = [];
        try {
            MODULE_CONFIGS.forEach(config => {
                if (!config || config.ignoreInLargeCalculator === "Sim" || !shouldProcessModule(config.filter, selectedFilter)) {
                    return; // Skip this module
                }

                logDebug(`calculateSizes: Processing module ${config.id} for measurement ${measurement}mm`);
                let moduleRows = [];
                try {
                    moduleRows = generateRowsForModule(config, measurement);
                } catch (e) {
                    console.error(`Error generating rows for module ${config?.id || 'UNKNOWN_ID'}:`, e);
                    // Create a placeholder error row
                    const linkMatch = config?.link?.match(/href='([^']*)'/i);
                    const href = linkMatch?.[1] || '#';
                    const imgUrl = config?.imageUrl || '';
                    const imgAlt = config?.imageAlt || config?.name || 'Imagem do Produto';
                    const imgHtml = `<a href='${href}' target='_blank' rel='noopener'><img src='${imgUrl}' alt="${imgAlt}" class='product-image' loading='lazy'></a>`;
                    moduleRows.push({ size: "Erro ao processar", link: config?.link || "N/A", image: imgHtml, width: "", status: 'rangeWarning', moduleId: config?.id || 'ERROR_ID', brand: config?.brand || "N/A", sortKey: measurement });
                }

                if (moduleRows.length === 0 && config.calculationType !== 'special') {
                    logDebug(`calculateSizes: No rows generated for module ${config.id}, adding placeholder warning.`);
                    const linkMatch = config.link?.match(/href='([^']*)'/i); const href = linkMatch?.[1] || '#';
                    const imgUrl = config.imageUrl || ''; const imgAlt = config.imageAlt || config.name || 'Imagem do Produto';
                    const imgHtml = `<a href='${href}' target='_blank' rel='noopener'><img src='${imgUrl}' alt="${imgAlt}" class='product-image' loading='lazy'></a>`;
                    let message = "❌ Tam. Inadequado";
                    // Add logic to determine if foot is too small or too large for the model
                    allRows.push({ size: message, link: config.link, image: imgHtml, width: "", status: 'rangeWarning', moduleId: config.id, brand: config.brand, sortKey: measurement });
                } else {
                    allRows = allRows.concat(moduleRows);
                }
            });
        } catch (e) {
            console.error("Error looping through MODULE_CONFIGS in calculateSizes:", e);
            if (resultsDiv) try { resultsDiv.innerHTML = "<p class='error'>Erro fatal ao processar modelos (E06).</p>"; resultsDiv.classList.remove('calculating'); } catch (re) { }
            if (loadingIndicator) try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (le) { }
            if (mainFilterButtonWrapper) try { mainFilterButtonWrapper.style.display = 'none'; } catch (eBtn) { }
            currentResults = []; // NEW: Clear any previous results
            return;
        }

        // NEW: Store the full, raw results in the global variable
        currentResults = allRows;
        logDebug("calculateSizes: All modules processed. Total rows generated and stored:", currentResults.length);

        // Sort and render the table
        let tableElement = null;
        try {
            // Sort a *copy* of the results for the initial display
            const sortedRows = [...currentResults].sort((a, b) => {
                // --- NEW: Meias (Socks) Rule ---
                const aIsMeias = a.isMeias === true;
                const bIsMeias = b.isMeias === true;

                // If a is socks and b isn't, 'a' goes to the end.
                if (aIsMeias && !bIsMeias) return 1;
                // If b is socks and a isn't, 'b' goes to the end.
                if (!aIsMeias && bIsMeias) return -1;
                // --- End of New Rule ---

                // If we get here, neither (or both) are socks, so apply the default sort.
                return (a.brand || '').localeCompare(b.brand || '');
            });
            logDebug("calculateSizes: Rows sorted. Rendering initial table...");
            tableElement = renderTable(sortedRows);
        } catch (e) {
            console.error("Error sorting or rendering table in calculateSizes:", e);
            if (resultsDiv) try { resultsDiv.innerHTML = "<p class='error'>Erro ao mostrar resultados (E07).</p>"; } catch (re) { }
        }

        if (resultsDiv) try { resultsDiv.classList.remove('calculating'); } catch (e) { }
        if (mainFilterButtonWrapper && inputResult.valid) { try { mainFilterButtonWrapper.style.display = 'block'; } catch (e) { } }

        if (tableElement) {
            if (loadingIndicator) try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (e) { }
            logDebug("calculateSizes: Table rendered. Initiating async enhancements and creating controls.");

            // Run async stock/sale checks
            addAsyncEnhancements(tableElement).catch(e => console.error("Error during async enhancements:", e));

            // NEW: Create and display the filter/sort controls
            createAndInjectControls();

        } else {
            if (loadingIndicator) try { loadingIndicator.style.display = 'none'; loadingIndicator.innerHTML = ''; } catch (e) { }
            logDebug("calculateSizes: No table element rendered. Async enhancements and controls skipped.");
            if (actionsContainer) try { actionsContainer.style.display = 'none'; } catch (e) { }
            if (copyButton) try { copyButton.disabled = true; } catch (e) { }
        }

        performance.mark('calc-end');
        try {
            performance.measure('calc-duration-total', 'calc-start', 'calc-end');
            const duration = performance.getEntriesByName('calc-duration-total')[0]?.duration;
            if (duration) logDebug(`Calculation and Rendering total time: ${duration.toFixed(2)} ms`);
        } catch (e) { }
        performance.clearMarks();
        performance.clearMeasures();
        logDebug("calculateSizes: Process finished.");
    }
    /**
     * Extracts a numeric shoe size from a result row for sorting.
     * Handles complex HTML strings, size ranges (takes the first number), and non-numeric sizes.
     * @param {object} row - The results row object.
     * @returns {number} The numeric size, or Infinity if not found.
     */
    function getNumericSizeForRow(row) {
        if (!row || typeof row.size !== 'string') return Infinity;

        // 1. Strip all HTML tags and leading symbols/emojis
        const cleanedString = row.size
            .replace(/<[^>]*>/g, '')         // Remove HTML tags
            .replace(/^[✅⚠️❌❗👇👟🤚🩰]\s*/, '') // Remove leading status icons
            .trim();

        // 2. Parse the first floating-point number from the cleaned string
        const numericValue = parseFloat(cleanedString);

        // 3. Return the number, or Infinity if it's not a valid number (e.g., "M", "L")
        //    This pushes non-numeric sizes to the end of the sorted list.
        return isNaN(numericValue) ? Infinity : numericValue;
    }
    /**
     * Creates the filter/sort UI, populates it, and attaches event listeners.
     * This is the main function to call after the initial table is rendered.
     */
    function createAndInjectControls() {
        const controlsContainer = document.getElementById('results-controls');
        if (!controlsContainer || currentResults.length === 0) {
            if (controlsContainer) controlsContainer.style.display = 'none';
            return; // Don't show controls if there are no results
        }

        // Inject the HTML structure for the controls.
        // "Marca (A-Z)" is now the default active button.
        controlsContainer.innerHTML = `
        <div style="display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 1rem 1.5rem;">
            <div class="filter-group">
                <label for="brand-filter" style="margin-right: 0.5rem; font-weight: 500;">Filtrar Marca:</label>
                <select id="brand-filter" style="padding: 0.4rem; border-radius: 4px; border: 1px solid #ccc;">
                    <option value="all">Todas as Marcas</option>
                    <!-- Brand options will be populated by populateBrandFilter() -->
                </select>
            </div>
            <div class="sort-group" style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="font-weight: 500;">Ordenar por:</span>
                <button class="action-button sort-btn" data-sort="size">Por tamanhos</button> 
                <button class="action-button sort-btn active" data-sort="brand">Marca (A-Z)</button> <!-- MOVED "active" CLASS HERE -->
            </div>
        </div>
    `;

        // Unify the button styles using JavaScript for consistency
        const sortButtons = controlsContainer.querySelectorAll('.sort-btn');
        sortButtons.forEach(button => {
            // Common styles
            button.style.padding = '0.4rem 0.8rem';
            button.style.fontSize = '0.9rem';
            button.style.height = 'auto';
            button.style.lineHeight = '1.2';

            // Differentiate active vs. inactive
            if (button.classList.contains('active')) {
                button.style.backgroundColor = '#e67e22'; // Active color
            } else {
                button.style.backgroundColor = '#7f8c8d'; // Inactive color
            }
        });

        controlsContainer.style.display = 'block';

        // Now that the elements exist, populate the dropdown and add the listeners
        populateBrandFilter();
        attachControlListeners();
    }

    /**
     * Populates the brand filter dropdown with unique brands from the current results.
     */
    function populateBrandFilter() {
        const brandFilterSelect = document.getElementById('brand-filter');
        if (!brandFilterSelect) return;

        // Use a Set to get a unique list of brand names automatically
        const brands = new Set(currentResults.map(row => row.brand).filter(Boolean)); // .filter(Boolean) removes any undefined/null brands

        // Sort brands alphabetically and add them as options
        Array.from(brands).sort((a, b) => a.localeCompare(b)).forEach(brand => {
            const option = document.createElement('option');
            option.value = brand;
            option.textContent = brand;
            brandFilterSelect.appendChild(option);
        });
    }

    /**
     * Attaches the necessary event listeners to the filter and sort controls.
     */
    function attachControlListeners() {
        const brandFilter = document.getElementById('brand-filter');
        const sortButtons = document.querySelectorAll('.sort-btn');

        if (brandFilter) {
            brandFilter.addEventListener('change', updateResultsDisplay);
        }

        sortButtons.forEach(button => {
            button.addEventListener('click', () => {
                if (button.classList.contains('active')) return; // Do nothing if already active

                sortButtons.forEach(btn => {
                    btn.classList.remove('active');
                    btn.style.backgroundColor = '#7f8c8d'; // Reset color for inactive buttons
                });
                button.classList.add('active');
                button.style.backgroundColor = '#e67e22'; // Active color

                updateResultsDisplay();
            });
        });
    }

    /**
     * This is the core function that re-filters and re-sorts the data, then re-renders the table.
     */
    function updateResultsDisplay() {
        logDebug("Updating results display based on filter/sort changes...");
        const brandFilter = document.getElementById('brand-filter');
        const selectedBrand = brandFilter ? brandFilter.value : 'all';
        const activeSortButton = document.querySelector('.sort-btn.active');
        const sortBy = activeSortButton ? activeSortButton.dataset.sort : 'default';

        // 1. Start with a fresh copy of the original results
        let processedRows = [...currentResults];

        // 2. Apply Brand Filter
        if (selectedBrand !== 'all') {
            processedRows = processedRows.filter(row => row.brand === selectedBrand);
        }

        // 3. Apply Sorting
        if (sortBy === 'brand') {
            processedRows.sort((a, b) => {
                // --- NEW: Meias (Socks) Rule ---
                const aIsMeias = a.isMeias === true;
                const bIsMeias = b.isMeias === true;
                if (aIsMeias && !bIsMeias) return 1;
                if (!aIsMeias && bIsMeias) return -1;
                // --- End of New Rule ---

                const brandA = a.brand || '';
                const brandB = b.brand || '';
                return brandA.localeCompare(brandB);
            });
        } else { // This is now the 'size' sort by default
            processedRows.sort((a, b) => {
                // --- NEW: Meias (Socks) Rule ---
                const aIsMeias = a.isMeias === true;
                const bIsMeias = b.isMeias === true;
                if (aIsMeias && !bIsMeias) return 1;
                if (!aIsMeias && bIsMeias) return -1;
                // --- End of New Rule ---

                return getNumericSizeForRow(a) - getNumericSizeForRow(b);
            });
        }

        // 4. Re-render the table with the new data
        const newTableElement = renderTable(processedRows);

        // 5. IMPORTANT: Re-run async enhancements on the newly rendered table
        if (newTableElement) {
            addAsyncEnhancements(newTableElement).catch(e => console.error("Error re-running enhancements:", e));
        }
    }

    // --------- EVENT LISTENERS & INITIALIZATION (Function called by DOMContentLoaded and config loader) -----------
    function initializeApp() {
        if (!isConfigLoaded) {
            logDebug("initializeApp: Configs not yet loaded. Aborting UI init for now. Will retry when configs are ready.");
            // loadModuleConfigs will call initializeApp again once data is ready.
            return;
        }

        if (!MODULE_CONFIGS || MODULE_CONFIGS.length === 0) {
            logDebug("initializeApp: MODULE_CONFIGS is empty even after load attempt. Critical error.");
            const resultsDiv = document.getElementById("results");
            if (resultsDiv) {
                try { resultsDiv.innerHTML = "<p class='error'>Erro Crítico: Dados de configuração em falta ou vazios (E03).</p>"; } catch (e) { }
            }
            try { document.getElementById("measurement")?.setAttribute('disabled', 'true'); } catch (e) { }
            try { document.getElementById("calc-button1")?.setAttribute('disabled', 'true'); } catch (e) { }
            return;
        }

        logDebug("DOM ready and configs loaded. Initializing calculator UI and event listeners...");

        // --- Get Element References ---
        const inputField = document.getElementById("measurement");
        const resultsDiv = document.getElementById("results"); // Also used in calculateButton catch
        const calculateButton = document.getElementById("calc-button1");
        const loadingIndicator = document.getElementById('calc-loading-indicator');
        const actionsContainer = document.getElementById("result-actions-container");
        const copyLinkButton = document.getElementById("copy-link-icon-button");
        const mainFilterButtonWrapper = document.getElementById('main-filter-button-wrapper');

        const openFilterModalButton = document.getElementById('open-filter-modal-button');
        const filterModalOverlay = document.getElementById('filter-modal-overlay');
        const filterModalCloseButton = document.getElementById('filter-modal-close');
        const applyFiltersButton = document.getElementById('apply-filters-button');
        const filterImagesInModal = document.querySelectorAll('#modal-filter-options-container .filter-image');
        // Note: Blanditos popup elements and Product Size popup elements are fetched within their respective showPopup functions.

        // --- Check Essential Base Elements ---
        if (!inputField || !resultsDiv || !calculateButton || !loadingIndicator || !actionsContainer || !copyLinkButton || !mainFilterButtonWrapper) {
            console.warn("Initialization Warning: One or more core calculator HTML elements are missing. Functionality may be impaired.");
            if (!inputField || !resultsDiv) {
                console.error("Calculator cannot function without input field and results area. Aborting initializeApp.");
                if (resultsDiv) try { resultsDiv.innerHTML = "<p class='error'>Erro: Elementos essenciais da calculadora em falta (E04).</p>"; } catch (e) { }
                return;
            }
        }

        // --- Initial State Setup ---
        try {
            if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
            if (loadingIndicator) loadingIndicator.style.display = 'none';
            if (actionsContainer) actionsContainer.style.display = "none";
            if (copyLinkButton) copyLinkButton.disabled = true;
            if (mainFilterButtonWrapper) mainFilterButtonWrapper.style.display = 'none';
        } catch (e) {
            console.error("Error setting initial UI states in initializeApp:", e);
        }

        // --- URL Parameter Processing ---
        let triggeredByURL = false;
        try {
            const params = new URLSearchParams(window.location.search);
            const measurementParam = params.get('medida');
            if (measurementParam && inputField && calculateButton) {
                logDebug("URL parameter 'medida' found:", measurementParam);
                const value = parseFloat(measurementParam.replace(',', '.'));
                if (!isNaN(value) && value >= 70 && value <= 290) {
                    inputField.value = Math.round(value);
                    // Delay slightly to ensure everything, including potentially late-arriving configs, is ready.
                    setTimeout(() => {
                        const currentCalcBtn = document.getElementById("calc-button1"); // Re-fetch in case of DOM changes
                        if (currentCalcBtn && !currentCalcBtn.disabled && isConfigLoaded) { // Check isConfigLoaded again
                            logDebug("Triggering calculation from URL parameter...");
                            disableButton();
                            calculateSizes();
                            triggeredByURL = true;
                        } else {
                            logDebug("Could not trigger calculation from URL (button disabled, missing, or configs not ready). Will attempt on next interaction if input valid.");
                        }
                    }, 250); // Increased delay slightly
                } else {
                    logDebug("Invalid 'medida' parameter value:", measurementParam);
                    if (resultsDiv) try { resultsDiv.innerHTML = `<p class='error'>Medida inválida (${measurementParam}) no link.</p>`; } catch (e) { }
                }
                // Clean the URL parameter
                try {
                    const cleanSearch = window.location.search.replace(/[\?&]medida=[^&]+/, '').replace(/^&/, '?');
                    const cleanURL = window.location.pathname + (cleanSearch === '?' ? '' : cleanSearch) + window.location.hash;
                    history.replaceState(null, '', cleanURL);
                } catch (urlError) {
                    console.warn("Could not clean URL parameter:", urlError);
                }
            }
        } catch (e) {
            console.error("Error processing URL parameters in initializeApp:", e);
        }

        // --- Modal de Filtros Logic ---
        if (openFilterModalButton && filterModalOverlay) {
            openFilterModalButton.addEventListener('click', () => {
                logDebug("Opening filter modal.");
                filterModalOverlay.style.display = 'flex';
                setTimeout(() => { if (filterModalOverlay) filterModalOverlay.classList.add('active'); }, 10);
            });
        } else {
            logDebug("Filter modal open button or overlay not found.");
        }

        function closeFilterModal() {
            if (filterModalOverlay && filterModalOverlay.classList.contains('active')) {
                logDebug("Closing filter modal.");
                filterModalOverlay.classList.remove('active');
                setTimeout(() => { if (filterModalOverlay) filterModalOverlay.style.display = 'none'; }, 300);
            }
        }

        if (filterModalCloseButton) {
            filterModalCloseButton.addEventListener('click', closeFilterModal);
        } else {
            logDebug("Filter modal close button not found.");
        }

        if (filterModalOverlay) {
            filterModalOverlay.addEventListener('click', (event) => {
                if (event.target === filterModalOverlay) {
                    closeFilterModal();
                }
            });
        }

        if (filterImagesInModal && filterImagesInModal.length > 0) {
            filterImagesInModal.forEach(img => {
                img.addEventListener('click', function () {
                    try {
                        const value = this.dataset.value;
                        const correspondingRadio = document.querySelector(`#gotu-barefoot-calculator-app input[name="filter"][value="${value}"]`);
                        if (correspondingRadio && !correspondingRadio.checked) {
                            logDebug(`Filter '${value}' selected in modal (image clicked).`);
                            correspondingRadio.checked = true;
                            filterImagesInModal.forEach(innerImg => { innerImg.classList.toggle('selected', innerImg.dataset.value === value); });
                        }
                    } catch (filterClickError) {
                        console.error("Error handling filter image click in modal:", filterClickError);
                    }
                });
            });
        } else {
            logDebug("Filter images within modal not found.");
        }

        if (applyFiltersButton) {
            applyFiltersButton.addEventListener('click', () => {
                logDebug("Apply Filters button clicked from modal.");
                closeFilterModal();
                if (inputField?.value.trim()) {
                    const inputValidationResult = getMeasurementInput(); // Ensure it's valid before calculating
                    if (inputValidationResult.valid) {
                        logDebug("Input valid, recalculating with new filter.");
                        disableButton();
                        calculateSizes();
                    } else {
                        logDebug("Input invalid after applying filter, not recalculating.");
                    }
                } else {
                    logDebug("Input field empty after applying filter.");
                    if (resultsDiv) resultsDiv.innerHTML = "<p>Filtro selecionado. Introduza a medida para ver os resultados.</p>";
                    if (actionsContainer) actionsContainer.style.display = 'none';
                    if (copyLinkButton) copyLinkButton.disabled = true;
                    if (meiasIntervalId) { try { clearInterval(meiasIntervalId); meiasIntervalId = null; } catch (e) { } }
                }
            });
        } else {
            logDebug("Apply filters button not found.");
        }

        // --- Input Debounce Logic ---
        let calculationTimeout;
        const debounceDelay = 600;
        const debouncedInputHandler = () => {
            clearTimeout(calculationTimeout);
            // Re-fetch elements within handler in case they are removed/re-added by other logic (unlikely here but good practice)
            const currentInputField = document.getElementById("measurement");
            const currentResultsDiv = document.getElementById("results");
            const currentLoader = document.getElementById('calc-loading-indicator');
            const currentActions = document.getElementById("result-actions-container");
            const currentCopyBtn = document.getElementById("copy-link-icon-button");
            // const currentMainFilterButtonWrapper = document.getElementById('main-filter-button-wrapper'); // Not directly manipulated by debounce

            if (!currentInputField || !currentResultsDiv || !currentLoader || !currentActions || !currentCopyBtn) {
                console.warn("Debounce Handler: Missing one or more required UI elements.");
                return;
            }

            calculationTimeout = setTimeout(() => {
                const value = currentInputField.value.trim();
                if (currentResultsDiv) currentResultsDiv.classList.remove('calculating');

                const resetUiToInactive = () => {
                    if (currentLoader) { currentLoader.style.display = 'none'; currentLoader.innerHTML = ''; }
                    if (currentActions) currentActions.style.display = 'none';
                    if (currentCopyBtn) currentCopyBtn.disabled = true;
                    if (meiasIntervalId) { clearInterval(meiasIntervalId); meiasIntervalId = null; }
                };

                if (value === "") {
                    logDebug("Debounced input: Value is empty.");
                    if (currentResultsDiv) currentResultsDiv.innerHTML = "<p>Introduza a medida.</p>";
                    resetUiToInactive();
                    return;
                }

                if (/^[0-9]+([,.][0-9]*)?$/.test(value.replace(/\s/g, ''))) {
                    logDebug("Debounced input: Valid format detected. No auto-calculation from input event.");
                    const resultsText = currentResultsDiv.textContent || currentResultsDiv.innerText || "";
                    // Only clear "Formato inválido" if it was previously shown.
                    if (resultsText.includes("Formato de medida inválido")) {
                        if (currentResultsDiv) currentResultsDiv.innerHTML = "<p>Introduza a medida e clique em Calcular.</p>";
                    }
                    // Do not reset all UI here, just ensure no invalid message persists if format is now okay.
                    // Calculation is only triggered by button.
                } else {
                    logDebug("Debounced input: Invalid format.");
                    if (currentResultsDiv) currentResultsDiv.innerHTML = "<p>Formato de medida inválido.</p>";
                    resetUiToInactive(); // Reset if format is actively invalid
                }
            }, debounceDelay);
        };

        if (inputField) {
            inputField.addEventListener('input', debouncedInputHandler);
        } else {
            console.warn("Input field not found, debounced input handler not attached.");
        }

        // --- Calculate Button Listener (with aggressive logging as requested) ---
        if (calculateButton) {
            calculateButton.addEventListener("click", () => {
                console.log("!!! Calculate button clicked - TRY block starting !!!");
                // resultsDiv is already defined in the outer scope of initializeApp

                try {
                    console.log("1. Calling getMeasurementInput()...");
                    const checkResult = getMeasurementInput(); // This also clears resultsDiv and hides filter button if invalid
                    console.log("2. getMeasurementInput() returned:", checkResult);

                    if (checkResult.valid) {
                        console.log("3. Measurement is VALID. Disabling button and calling calculateSizes().");
                        disableButton();
                        // setTimeout(calculateSizes, 10); // Using direct call now
                        calculateSizes(); // Will use global MODULE_CONFIGS
                        console.log("4. calculateSizes() call completed.");
                    } else {
                        console.log("3. Measurement is INVALID. checkResult.element:", checkResult.element);
                        if (checkResult.element) {
                            console.log("3a. Applying shake animation to element:", checkResult.element);
                            try {
                                checkResult.element.classList.add('input-invalid-shake');
                                setTimeout(() => {
                                    try { if (checkResult.element) checkResult.element.classList.remove('input-invalid-shake'); }
                                    catch (e) { console.warn("Minor error removing shake:", e); }
                                }, 500);
                            } catch (shakeError) {
                                console.error("Error applying shake animation:", shakeError);
                            }
                        } else {
                            console.log("3b. No element found in checkResult to apply shake to.");
                        }
                    }
                    console.log("!!! Calculate button - TRY block ending (apparently successfully) !!!");
                } catch (e) {
                    console.error("!!! CRITICAL ERROR in Calculate button click listener CATCH BLOCK !!!", e);
                    console.error("Error Name:", e.name);
                    console.error("Error Message:", e.message);
                    console.error("Error Stack:", e.stack);

                    if (resultsDiv) {
                        try {
                            resultsDiv.innerHTML = "<p class='error'>Ocorreu um erro. (Debug ID: CALC_BTN_CATCH)</p>";
                        } catch (re) {
                            console.error("Error setting error message in resultsDiv:", re);
                        }
                    } else {
                        console.error("resultsDiv not found in catch block for calculateButton!");
                    }

                    const btn = document.getElementById("calc-button1"); // Re-fetch
                    if (btn) {
                        try {
                            console.log("Attempting to re-enable button after error.");
                            btn.disabled = false;
                            btn.style.opacity = '1';
                            btn.style.cursor = 'pointer';
                            btn.innerHTML = 'Calcular';
                        } catch (reEnableError) {
                            console.error("Error re-enabling button:", reEnableError);
                        }
                    }
                }
            });
        } else {
            console.warn("Calculate button not found, click listener not attached.");
        }

        // --- Results Click Listener (Event Delegation for Popups/Links) ---
        if (resultsDiv) {
            resultsDiv.addEventListener('click', (event) => {
                try {
                    const targetElement = event.target;
                    // Click on a clickable size cell (TD)
                    const sizeCell = targetElement.closest('td.clickable-size[data-size]');
                    if (sizeCell) {
                        logDebug("Click detected on clickable (2-digit) size cell.");
                        event.preventDefault(); event.stopPropagation();
                        const clickedSize = sizeCell.dataset.size;
                        const row = sizeCell.closest('tr[data-module-id]');
                        const moduleId = row?.dataset.moduleId;
                        const linkEl = row?.querySelector('td:nth-child(2) a[href*="/collections/"]');
                        const baseCollectionUrl = linkEl?.href;
                        const brandVariantCell = row?.querySelector('td:nth-child(2)');
                        const brandVariantText = brandVariantCell?.textContent?.trim() || '';
                        const status = row?.dataset.status || 'ideal';

                        if (!clickedSize || !moduleId) { console.warn("Size cell click missing data (size or module ID)."); return; }
                        logDebug(`Size ${clickedSize} clicked. Module ID: ${moduleId}. Base Collection URL: ${baseCollectionUrl}. Brand/Variant: ${brandVariantText}. Status: ${status}`);

                        if (SUB_COLLECTION_SELECTORS.hasOwnProperty(moduleId)) {
                            logDebug(`-> Module '${moduleId}' requires sub-collection selector.`);
                            showSubCollectionSelectorPopup(clickedSize, SUB_COLLECTION_SELECTORS[moduleId], brandVariantText, status);
                        } else if (baseCollectionUrl) {
                            logDebug(`-> Module '${moduleId}' does NOT require sub-selector. Showing product grid directly.`);
                            showProductSizePopup(clickedSize, baseCollectionUrl, brandVariantText, status);
                        } else {
                            logDebug(`-> Module '${moduleId}' has no sub-selector config and no collection URL. Cannot show stock.`);
                        }
                        return; // Handled click
                    }

                    // Click on a collection link (Brand/Variant or Image column)
                    const link = targetElement.closest('td:nth-child(2) a[href*="/collections/"], td:nth-child(3) a[href*="/collections/"]');
                    if (link) {
                        logDebug("Click detected on collection link.");
                        event.preventDefault(); event.stopPropagation();
                        const href = link.getAttribute('href');
                        if (!href) { logDebug("Link has no href."); return; }

                        const row = link.closest('tr[data-module-id]');
                        const sizeCellEl = row?.querySelector('td:first-child');
                        const linkText = (link.textContent || '').trim();
                        const moduleId = row?.dataset.moduleId;
                        const blanditosBaseUrl = 'https://gotu.pt/collections/colecao-blanditos';
                        const blanditosBrandName = 'Blanditos';
                        let filterSize = null;

                        if (sizeCellEl) {
                            const baseSizeText = extractBaseSizeText(sizeCellEl.innerHTML);
                            if (baseSizeText && isTwoDigitNumberString(baseSizeText)) {
                                filterSize = baseSizeText;
                            }
                            logDebug(`Extracted size for link click context: ${filterSize} (null if not 2-digit)`);
                        }

                        // Special Blanditos navigation popup logic
                        if (link.closest('td:nth-child(2)')) { // Only for Brand/Variant column links
                            let popupOptionsToShow = null;
                            if (linkText.toLowerCase() === blanditosBrandName.toLowerCase() && href === blanditosBaseUrl && moduleId === 'blanditos-small') {
                                popupOptionsToShow = blanditosPopupOptions;
                                logDebug("-> Matched Blanditos main link for navigation popup.");
                            } else if (moduleId === 'blanditos-sapatilha-larga') {
                                popupOptionsToShow = blanditosSolaLargaPopupOptions.length ? blanditosSolaLargaPopupOptions : blanditosPopupOptions; // Fallback to general if specific is empty
                                logDebug("-> Matched Blanditos Sola Larga link for navigation popup.");
                            }

                            if (popupOptionsToShow && popupOptionsToShow.length > 0) {
                                logDebug(`-> Triggering Blanditos LINK popup (for navigation). Size to potentially filter: ${filterSize}`);
                                showBlanditosPopup(popupOptionsToShow, filterSize);
                                return; // Handled click
                            }
                        }

                        // Standard link navigation (potentially with size filter)
                        logDebug("-> No special navigation popup. Proceeding with standard link navigation/filtering.");
                        let finalUrl = href;
                        if (filterSize) {
                            const key = SHOPIFY_SIZE_FILTER_KEY, val = filterSize;
                            logDebug(`Attempting to add filter to navigation link: ${key}=${val}`);
                            try {
                                const urlObj = new URL(href, window.location.origin);
                                if (!urlObj.searchParams.getAll(key).includes(val)) { urlObj.searchParams.append(key, val); }
                                let tempUrl = urlObj.toString();
                                const encodedKey = encodeURIComponent(key).replace(/%20/g, '+');
                                const correctKey = key;
                                const regexKey = new RegExp(encodeURIComponent(encodedKey).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=', 'g');
                                if (regexKey.test(tempUrl)) { finalUrl = tempUrl.replace(regexKey, correctKey + '='); }
                                else { finalUrl = tempUrl; }
                            } catch (e) {
                                console.warn("Error building filtered URL, using simple append fallback:", e);
                                finalUrl = href; // Reset to original href on error
                                const separator = finalUrl.includes('?') ? '&' : '?';
                                const param = `${key}=${encodeURIComponent(val)}`;
                                let baseUrl = finalUrl, hash = '';
                                if (finalUrl.includes('#')) { [baseUrl, hash] = finalUrl.split('#'); hash = '#' + hash; }
                                if (!baseUrl.includes(param) && !baseUrl.includes(key + '=' + val)) {
                                    finalUrl = baseUrl + separator + param + hash;
                                } else {
                                    finalUrl = href; // Use original if already seems present
                                }
                            }
                            logDebug("Final Navigation URL with filter:", finalUrl);
                        } else {
                            logDebug("No suitable (2-digit) filterable size found for navigation link click.");
                        }
                        const target = link.getAttribute('target');
                        logDebug(`Navigating (from link) to: ${finalUrl}, Target: ${target || '_self'}`);
                        if (target === '_blank') { window.open(finalUrl, '_blank', 'noopener'); }
                        else { window.location.href = finalUrl; }
                    }
                } catch (e) {
                    console.error("Error in results click listener:", e);
                }
            });
        } else {
            console.warn("Results container (resultsDiv) not found, click listener not attached.");
        }

        // --- Initial Filter State Sync (for modal) ---
        try {
            const initialFilterValue = getSelectedFilter();
            if (filterImagesInModal && filterImagesInModal.length > 0) {
                filterImagesInModal.forEach(img => {
                    try { img.classList.toggle('selected', img.dataset.value === initialFilterValue); } catch (e) { }
                });
            }
        } catch (e) {
            console.warn("Error syncing initial filter state for modal:", e);
        }

        // --- Initial Calculation (if input has value on load, but not triggered by URL param) ---
        if (!triggeredByURL && inputField?.value.trim()) {
            logDebug("initializeApp: Input field has value on load (not from URL).");
            const checkResult = getMeasurementInput(); // Ensure this doesn't clear a valid resultsDiv unnecessarily if called here
            if (checkResult.valid) {
                logDebug("Initial load with valid input, triggering calculation...");
                setTimeout(() => {
                    if (document.getElementById("calc-button1") && isConfigLoaded) { // Check isConfigLoaded again
                        disableButton();
                        calculateSizes();
                    } else {
                        logDebug("Initial calc skipped: button missing or configs not ready.");
                    }
                }, 100); // Small delay
            } else {
                logDebug("Initial load, input has value but it's not valid according to getMeasurementInput.");
            }
        } else if (!triggeredByURL && resultsDiv && resultsDiv.innerHTML === "") {
            // Only set this if results are truly empty and not because getMeasurementInput cleared them
            logDebug("initializeApp: No URL trigger, input empty, results empty. Setting initial message.");
            try { resultsDiv.innerHTML = "<p>Introduza a medida para começar.</p>"; } catch (e) { }
        }

        logDebug("Gotu Calculator UI Initialization Complete.");
    } // --- End of initializeApp ---


    // --------- ASYNCHRONOUS CONFIGURATION LOADING (Entry Point) -----------
    async function loadModuleConfigs() {
        logDebug("Attempting to load module configurations from JSON...");
        let configUrl = "ERROR_URL_NOT_INITIALLY_SET"; // Default to an obviously wrong URL to catch errors

        try {
            // Step 1: Determine the configuration URL
            if (window.calculatorAppConfig &&
                typeof window.calculatorAppConfig.jsonFileUrl === 'string' &&
                window.calculatorAppConfig.jsonFileUrl.trim() !== '') {
                configUrl = window.calculatorAppConfig.jsonFileUrl;
                logDebug("SUCCESS: Using config URL from window.calculatorAppConfig.jsonFileUrl:", configUrl);
            } else {
                console.error("CRITICAL FAILURE: window.calculatorAppConfig.jsonFileUrl is NOT SET or is not a valid string. This global variable MUST be set by a Liquid script block BEFORE this JavaScript file (calculadoras_teste.js) runs.");
                logDebug("Value of window.calculatorAppConfig at failure:", window.calculatorAppConfig); // Log the whole object for clues

                // Display error to the user and stop further processing for this function
                const resultsDiv = document.getElementById("results");
                if (resultsDiv) {
                    try { resultsDiv.innerHTML = "<p class='error'>Erro de configuração interna da aplicação (E01: URL do ficheiro de dados em falta). Contacte o suporte.</p>"; } catch (e) { }
                }
                // Optionally disable UI elements more broadly if this is a fatal setup error
                try { document.getElementById("measurement")?.setAttribute('disabled', 'true'); } catch (e) { }
                try { document.getElementById("calc-button1")?.setAttribute('disabled', 'true'); } catch (e) { }
                isConfigLoaded = false; // Explicitly set to false
                return; // Stop further execution of loadModuleConfigs
            }

            // Step 2: Fetch the configuration file
            logDebug(`Attempting to fetch config from determined URL: ${configUrl}`);
            const response = await fetch(configUrl);

            logDebug("Fetch response status:", response.status, response.statusText, "for effective URL:", response.url); // response.url shows the final URL after any redirects

            if (!response.ok) {
                let errorDetail = `Status: ${response.status} ${response.statusText}.`;
                try {
                    const errorText = await response.text();
                    errorDetail += ` Response: ${errorText.substring(0, 200)}...`; // Include part of the response if available
                    logDebug("Fetch response error text (if any):", errorText);
                } catch (textError) {
                    logDebug("Could not get error text from failed response.", textError);
                }
                throw new Error(`HTTP error while fetching configuration from ${response.url}. ${errorDetail}`);
            }

            // Step 3: Process the response
            const responseText = await response.text();
            logDebug("Raw JSON response text (first 500 chars):", responseText.substring(0, 500));

            if (responseText.trim() === "") {
                throw new Error("Received empty response for JSON configuration file. The file might be empty or incorrectly served.");
            }
            // Basic check to see if we accidentally got an HTML page (like a 404 page that returns 200 OK sometimes, or a redirect)
            if (responseText.trim().toLowerCase().startsWith("<html") || responseText.trim().toLowerCase().startsWith("<!doctype html")) {
                throw new Error("Received HTML content instead of JSON. This often indicates a server misconfiguration or an incorrect URL that resolved to an HTML page.");
            }

            // Step 4: Parse the JSON
            try {
                MODULE_CONFIGS = JSON.parse(responseText);
            } catch (parseError) {
                logDebug("JSON Parsing Error:", parseError);
                logDebug("Problematic JSON Text (first 1000 chars):", responseText.substring(0, 1000));
                throw new Error(`Failed to parse JSON configuration. Error: ${parseError.message}. Check if the JSON file is correctly formatted.`);
            }

            isConfigLoaded = true;
            logDebug("MODULE_CONFIGS loaded and parsed successfully from JSON. Number of modules:", MODULE_CONFIGS.length);

            // If the DOM is already loaded by the time configurations arrive, initialize the app's UI components.
            // This handles cases where fetching is very fast or DOMContentLoaded was delayed.
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                logDebug("DOM already loaded, and configs have just arrived. Initializing app UI now.");
                initializeApp(); // Ensure initializeApp is defined and handles UI setup
            }

        } catch (error) {
            console.error("CRITICAL ERROR in loadModuleConfigs. URL attempted:", configUrl, "Full Error details:", error);
            isConfigLoaded = false; // Ensure this is explicitly false on any error in the try block

            const resultsDiv = document.getElementById("results");
            if (resultsDiv) {
                try { resultsDiv.innerHTML = "<p class='error'>Erro Crítico: Falha ao carregar ou processar dados de configuração (E02). Tente recarregar a página. Verifique a consola do navegador para mais detalhes técnicos.</p>"; } catch (e) { }
            }
            // Optionally disable more UI elements if this is a fatal error
            try { document.getElementById("measurement")?.setAttribute('disabled', 'true'); } catch (e) { }
            try { document.getElementById("calc-button1")?.setAttribute('disabled', 'true'); } catch (e) { }
        }
    }
    // --------- SCRIPT EXECUTION START -----------
    // 1. Start loading the configuration immediately
    loadModuleConfigs();

    // 2. Set up the main app initialization to run after the DOM is ready
    //    initializeApp will also check if configs are loaded before proceeding.
    document.addEventListener("DOMContentLoaded", initializeApp);


    // --------- GLOBAL FUNCTIONS for Action Buttons (copyMeasurementLink, saveTableAsImage) -----------
    function copyMeasurementLink() {
        const inputField = document.getElementById("measurement"), copyButton = document.getElementById("copy-link-icon-button");
        if (!inputField || !copyButton) { return; }
        let measurementValue = NaN;
        try { if (inputField.value) { measurementValue = parseFloat(inputField.value.replace(',', '.')); } } catch (e) { }
        if (isNaN(measurementValue) || measurementValue < 70 || measurementValue > 290) {
            try { copyButton.classList.remove('copied-success'); copyButton.classList.add('copied-error'); copyButton.innerHTML = '❌'; copyButton.disabled = true; setTimeout(() => { const currentCopyBtn = document.getElementById("copy-link-icon-button"); if (currentCopyBtn) { try { currentCopyBtn.classList.remove('copied-error'); const hasResults = !!document.querySelector('#results .my-table'); currentCopyBtn.disabled = !hasResults; currentCopyBtn.innerHTML = '🔗'; } catch (resetError) { } } }, 2000); } catch (e) { } return;
        }
        const roundedMeasurement = Math.round(measurementValue);
        const shareUrl = `${window.location.origin}${window.location.pathname}?medida=${roundedMeasurement}`;
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(shareUrl).then(() => {
                try { copyButton.classList.remove('copied-error'); copyButton.classList.add('copied-success'); copyButton.innerHTML = '✅'; copyButton.disabled = true; setTimeout(() => { const currentCopyBtn = document.getElementById("copy-link-icon-button"); if (currentCopyBtn) { try { currentCopyBtn.classList.remove('copied-success'); currentCopyBtn.disabled = false; currentCopyBtn.innerHTML = '🔗'; } catch (resetSuccess) { } } }, 2000); } catch (e) { }
            }).catch(err => {
                try { copyButton.classList.remove('copied-success'); copyButton.classList.add('copied-error'); copyButton.innerHTML = '❌'; copyButton.disabled = true; setTimeout(() => { const currentCopyBtn = document.getElementById("copy-link-icon-button"); if (currentCopyBtn) { try { currentCopyBtn.classList.remove('copied-error'); currentCopyBtn.disabled = false; currentCopyBtn.innerHTML = '🔗'; } catch (resetFail) { } } }, 2000); } catch (e) { }
                try { alert(`Não foi possível copiar automaticamente.\nLink:\n${shareUrl}`); } catch (alertE) { }
            });
        } else { try { alert(`Link para partilhar:\n${shareUrl}`); } catch (alertE) { } }
    }

    function saveTableAsImage() {
        const tableElement = document.querySelector('#results .my-table');
        const actionsContainer = document.getElementById('result-actions-container');
        const saveButton = document.getElementById('save-table-button');
        if (!tableElement) { try { alert("Nenhuma tabela de resultados para guardar."); } catch (e) { } return; }
        if (typeof html2canvas === 'undefined') { try { alert("Erro: Funcionalidade de guardar imagem não disponível."); } catch (e) { } return; }
        if (!saveButton) { }
        let originalButtonHTML = '';
        if (saveButton) { try { originalButtonHTML = saveButton.innerHTML; saveButton.textContent = 'A Guardar...'; saveButton.disabled = true; } catch (e) { } }
        if (actionsContainer) { try { actionsContainer.style.visibility = 'hidden'; } catch (e) { } }
        html2canvas(tableElement, { scale: 2, useCORS: true, logging: DEBUG_MODE, backgroundColor: '#ffffff' })
            .then(canvas => {
                const link = document.createElement('a'); link.download = 'tabela_tamanhos_gotu.png';
                link.href = canvas.toDataURL("image/png"); document.body.appendChild(link); link.click(); document.body.removeChild(link);
                if (saveButton) { try { saveButton.classList.add('save-success'); saveButton.innerHTML = 'Guardado! ✅'; } catch (e) { } }
            })
            .catch(err => {
                try { alert('Ocorreu um erro ao guardar a imagem da tabela.'); } catch (e) { }
                if (saveButton) { try { saveButton.classList.add('save-error'); saveButton.innerHTML = 'Erro ❌'; } catch (e) { } }
            })
            .finally(() => {
                setTimeout(() => {
                    if (actionsContainer) try { actionsContainer.style.visibility = 'visible'; } catch (e) { }
                    if (saveButton) { try { saveButton.innerHTML = originalButtonHTML; saveButton.disabled = false; saveButton.classList.remove('save-success', 'save-error'); } catch (e) { if (saveButton) try { saveButton.textContent = "Guardar Tabela"; } catch (re) { } } }
                }, 2000);
            });
    }

    // --------- INTERACTIVE TUTORIAL LOGIC -----------
    // --------- INTERACTIVE TUTORIAL LOGIC -----------
    function startTutorial() {
        const steps = [
            {
                targetId: 'measurement',
                title: 'Passo 1: A Medida',
                text: 'Para este exemplo, vamos imaginar que o pé da criança mede 125mm.',
                preAction: () => {
                    document.getElementById('measurement').value = '125';
                }
            },
            {
                targetId: 'calc-button1',
                title: 'Passo 2: Calcular',
                text: 'Ao clicar em Calcular, procuramos na nossa base de dados...',
                postAction: () => {
                    document.getElementById('calc-button1').click();
                }
            },
            {
                title: 'Tamanhos Recomendados&nbsp;✅',
                text: 'Estes são os resultados ideais! A maioria do calçado respeitador na gotu tem margens de 8 a 11mm por exemplo, mas este tem margem de 3 a 7mm! Mas não te preocupes que a calculadora sabe todas as regras!\n\nAs opções abaixo: A ⚠️ laranja indica que a margem é um pouco maior/menor do que a margem recomendada. A vermelha ❌ indica que a margem é inadequada (Mesmo muito grande/pequeno, ou já não há tamanhos).',
                findTarget: () => Array.from(document.querySelectorAll('.ideal-section tr')).find(r => r.querySelector('.margin-text') && !r.textContent.includes('Attipas')) || document.getElementById('results')
            }
        ];

        let currentStepIndex = 0;

        let tooltip = document.getElementById('tutorial-tooltip');
        let spotlight = document.getElementById('tutorial-spotlight');

        if (!spotlight) {
            spotlight = document.createElement('div');
            spotlight.id = 'tutorial-spotlight';
            document.body.appendChild(spotlight);
        }

        if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.id = 'tutorial-tooltip';
            tooltip.innerHTML = `
            <h5 id="tutorial-tooltip-title"></h5>
            <p id="tutorial-tooltip-text"></p>
            <div class="tutorial-controls">
                <button id="tutorial-close-btn" class="tutorial-close-btn">Sair</button>
                <button id="tutorial-next-btn" class="tutorial-next-btn">Próximo</button>
            </div>
        `;
            document.body.appendChild(tooltip);
        }

        const closeBtn = document.getElementById('tutorial-close-btn');
        const nextBtn = document.getElementById('tutorial-next-btn');

        // Clean up previous event listeners to prevent duplicate triggers
        closeBtn.replaceWith(closeBtn.cloneNode(true));
        nextBtn.replaceWith(nextBtn.cloneNode(true));

        // Re-get the new DOM elements and add fresh listeners
        document.getElementById('tutorial-close-btn').addEventListener('click', endTutorial);

        document.getElementById('tutorial-next-btn').addEventListener('click', () => {
            const currentStep = steps[currentStepIndex];
            if (currentStep && currentStep.postAction) {
                currentStep.postAction();
            }

            currentStepIndex++;
            if (currentStepIndex >= steps.length) {
                endTutorial();
            } else {
                // Small delay to allow DOM to update if postAction ran a calculation
                if (currentStep && currentStep.postAction) {
                    setTimeout(() => showStep(currentStepIndex), 300);
                } else {
                    showStep(currentStepIndex);
                }
            }
        });

        function showStep(index) {
            const step = steps[index];
            if (step.preAction) {
                step.preAction();
            }

            let targetEl = null;

            if (step.findTarget) {
                targetEl = step.findTarget();
            } else if (step.targetId) {
                targetEl = document.getElementById(step.targetId);
            } else if (step.targetSelector) {
                targetEl = document.querySelector(step.targetSelector);
            }

            if (!targetEl && step.fallbackId) {
                targetEl = document.getElementById(step.fallbackId);
            }

            // Remove highlight from all previous
            document.querySelectorAll('.tutorial-highlight').forEach(el => el.classList.remove('tutorial-highlight'));

            if (!targetEl) {
                // If the element doesn't exist (e.g., no range warning rows for this specific measure), skip to next
                currentStepIndex++;
                if (currentStepIndex >= steps.length) {
                    endTutorial();
                } else {
                    showStep(currentStepIndex);
                }
                return;
            }

            // Scroll target into view
            targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

            // Add highlight (which creates the dark overlay via box-shadow)
            targetEl.classList.add('tutorial-highlight');

            // Update tooltip content
            document.getElementById('tutorial-tooltip-title').innerHTML = step.title;
            document.getElementById('tutorial-tooltip-text').innerHTML = step.text;

            const nextBtn = document.getElementById('tutorial-next-btn');
            if (index === steps.length - 1) {
                nextBtn.textContent = 'Concluir';
            } else {
                nextBtn.textContent = 'Próximo';
            }

            // Keep within document bounds horizontally
            const rect = targetEl.getBoundingClientRect();
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            const scrollX = window.scrollX || document.documentElement.scrollLeft;

            // Position Spotlight directly over Target
            if (spotlight) {
                // Expanding the frame slightly for breathing room
                spotlight.style.width = (rect.width + 10) + 'px';
                spotlight.style.height = (rect.height + 10) + 'px';
                spotlight.style.left = (rect.left + scrollX - 5) + 'px';
                spotlight.style.top = (rect.top + scrollY - 5) + 'px';
                spotlight.classList.add('visible');
            }

            let topPos = rect.bottom + scrollY + 15;
            let leftPos = rect.left + scrollX + (rect.width / 2) - 160; // Center tooltip (160 is half of 320px width)

            if (leftPos < 10) leftPos = 10;
            const maxLeft = document.documentElement.scrollWidth - 340;
            if (leftPos > maxLeft) leftPos = maxLeft;

            tooltip.style.top = topPos + 'px';
            tooltip.style.left = leftPos + 'px';

            tooltip.classList.add('visible');

            // Refined Check: Always ensure the target element clears the tooltip
            requestAnimationFrame(() => {
                const viewHeight = window.innerHeight;
                const viewWidth = window.innerWidth;

                // On mobile, the tooltip is a fixed bottom sheet that can span up to 60% of the screen height.
                // We must aggressively scroll the highlighted target to the very top 15% of the viewport.
                // On desktop, the tooltip floats alongside it, so 35% (upper-middle) is better.
                const offsetPercentage = viewWidth <= 480 ? 0.15 : 0.35;
                const targetScrollY = rect.top + scrollY - (viewHeight * offsetPercentage);
                window.scrollTo({ top: Math.max(0, targetScrollY), behavior: 'smooth' });
            });
        }

        function endTutorial() {
            document.querySelectorAll('.tutorial-highlight').forEach(el => el.classList.remove('tutorial-highlight'));
            if (tooltip) tooltip.classList.remove('visible');
            if (spotlight) spotlight.classList.remove('visible');

            // Return to top
            const title = document.getElementById('calc-title-h4');
            if (title) {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                const topOffset = title.getBoundingClientRect().top + scrollY - 20;
                window.scrollTo({ top: topOffset, behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }

        // Start first step
        showStep(0);
    }

    // Attach event listeners that used to be inline
    document.addEventListener('DOMContentLoaded', () => {
        const copyButton = document.getElementById('copy-link-icon-button');
        if (copyButton) {
            copyButton.addEventListener('click', copyMeasurementLink);
        }

        const saveButton = document.getElementById('save-table-button');
        if (saveButton) {
            saveButton.addEventListener('click', saveTableAsImage);
        }

        const tutorialStartBtn = document.getElementById('tutorial-start-btn');
        if (tutorialStartBtn) {
            tutorialStartBtn.addEventListener('click', startTutorial);
        }
    });

    logDebug("Calculator script parsed. Config loading initiated.");

})(); // End of IIFE